<template>
  <div class="person-center-tab-wrap m-main" ref="editorDOM">
    <div class="left-box">
      <div class="top-box">
        <img src="../images/presentation-img.png" alt="" />
        <span>个人中心</span>
      </div>
      <ul>
        <li @click="changeTab(3)" :class="{ active: activeTab == 3 }">
          <img src="../images/presentation-img3.png" alt="" />
          <span class="one-span">就诊人管理</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(4)" :class="{ active: activeTab == 4 }">
          <img src="../images/presentation-img4.png" alt="" />
          <span class="one-span">门诊预约记录</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(5)" :class="{ active: activeTab == 5 }">
          <img src="../images/presentation-img5.png" alt="" />
          <span class="one-span">体检预约记录</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(6)" :class="{ active: activeTab == 6 }">
          <img src="../images/presentation-img6.png" alt="" />
          <span class="one-span">报告查询</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
        <li @click="changeTab(7)" :class="{ active: activeTab == 7 }">
          <img src="../images/presentation-img7.png" alt="" />
          <span class="one-span">消费明细</span>
          <span class="two-span"><a-icon type="right"/></span>
        </li>
      </ul>
    </div>
    <div class="right-box">
      <!-- 就诊人管理 begin -->
      <div class="consultant-management" v-if="activeBox == 3">
        <div v-if="!SCREEN.mobile">
          <h2>就诊人管理</h2>
          <div class="add-consultant-people">
            <span class="one-span" @click="addPcConsultantPeople"
              >添加新的就诊人</span
            >
            <span class="two-span"
              >已有就诊人（{{ consultantData.length }}/5）</span
            >
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="
                ehealthCardFlag ? consultantECardColumns : consultantColumns
              "
              :data-source="consultantData"
              :pagination="false"
            >
              <template
                v-if="!ehealthCardFlag"
                slot="relationshipCode"
                slot-scope="text, record"
              >
                <span v-if="record.relationshipCode == 0">本人</span>
                <span v-if="record.relationshipCode == 1">子女</span>
                <span v-if="record.relationshipCode == 2">父母</span>
                <span v-if="record.relationshipCode == 3">夫妻</span>
                <span v-if="record.relationshipCode == 4">其它</span>
              </template>
              <template
                v-if="ehealthCardFlag"
                slot="eCard"
                slot-scope="text, record"
              >
                <div class="eCardArea">
                  <div class="eCardBox">
                    <div class="eCardFirstRow">
                      <div class="eCardLeft">
                        <div class="siChuan">
                          四川省卫生健康委员会
                        </div>
                        <div>
                          <span class="name">{{ record.name }}</span>
                          <span
                            class="relation"
                            v-if="record.relationshipCode == 0"
                            >(本人)</span
                          >
                          <span
                            class="relation"
                            v-if="record.relationshipCode == 1"
                            >(子女)</span
                          >
                          <span
                            class="relation"
                            v-if="record.relationshipCode == 2"
                            >(父母)</span
                          >
                          <span
                            class="relation"
                            v-if="record.relationshipCode == 3"
                            >(夫妻)</span
                          >
                          <span
                            class="relation"
                            v-if="record.relationshipCode == 4"
                            >(其他)</span
                          >
                        </div>
                        <div class="idNo">
                          {{ record.idNoHide }}
                        </div>
                      </div>
                      <div class="eCardRight">
                        <div class="rightFristRow">
                          <img
                            class="redCrossImg"
                            src="../images/eCard-redCross.png"
                            alt=""
                          />
                          <div class="content">电子健康卡</div>
                        </div>
                        <div class="qrCodeBox">
                          <img
                            class="logoImg"
                            src="../images/eCard-qr-middle.png"
                            alt=""
                          />
                          <div class="qrCode" :id="'eCardqrcode' + record.id">
                            二维码
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="eCardSecondRow">
                      中华人民共和国卫生健康委员会监制
                    </div>
                  </div>
                </div>
              </template>
              <template slot="action" slot-scope="text, record">
                <a
                  class="btn btn-blue"
                  @click="makeAnAppointmentRocord(record.hisId)"
                  >预约记录</a
                >
                <a
                  class="btn btn-blue"
                  @click="
                    cancelBind(
                      record.id,
                      record.relationshipCode,
                      record.relation
                    )
                  "
                  >解绑</a
                >
              </template>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <h2>就诊人管理</h2>
          <div class="add-consultant-people">
            <span class="one-span" @click="addMobileConsultantPeople"
              >添加新的就诊人</span
            >
            <span class="two-span"
              >已有就诊人（{{ consultantData.length }}/5）</span
            >
          </div>
          <div class="line"></div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in consultantData" :key="item.id + index">
              <li v-if="!ehealthCardFlag">
                <span class="one-span">姓名:</span
                ><span class="two-span">{{ item.name }}</span>
              </li>
              <li v-if="!ehealthCardFlag">
                <span class="one-span">诊疗卡号:</span
                ><span class="two-span">{{ item.cardNo }}</span>
              </li>
              <li v-if="!ehealthCardFlag">
                <span class="one-span">证件号:</span
                ><span class="two-span">{{ item.idNoHide }}</span>
              </li>
              <li v-if="!ehealthCardFlag">
                <span class="one-span">手机号:</span
                ><span class="two-span">{{ item.phone }}</span>
              </li>
              <li v-if="!ehealthCardFlag">
                <span class="one-span">关系:</span>
                <span class="two-span">
                  <span v-if="item.relationshipCode == 0">本人</span>
                  <span v-if="item.relationshipCode == 1">子女</span>
                  <span v-if="item.relationshipCode == 2">父母</span>
                  <span v-if="item.relationshipCode == 3">夫妻</span>
                  <span v-if="item.relationshipCode == 4">其它</span>
                </span>
              </li>
              <div v-if="ehealthCardFlag">
                <div class="eCardArea">
                  <div class="eCardBox">
                    <div class="eCardFirstRow">
                      <div class="eCardLeft">
                        <div class="siChuan">
                          四川省卫生健康委员会
                        </div>
                        <div>
                          <span class="name">{{ item.name }}</span>
                          <span
                            class="relation"
                            v-if="item.relationshipCode == 0"
                            >(本人)</span
                          >
                          <span
                            class="relation"
                            v-if="item.relationshipCode == 1"
                            >(子女)</span
                          >
                          <span
                            class="relation"
                            v-if="item.relationshipCode == 2"
                            >(父母)</span
                          >
                          <span
                            class="relation"
                            v-if="item.relationshipCode == 3"
                            >(夫妻)</span
                          >
                          <span
                            class="relation"
                            v-if="item.relationshipCode == 4"
                            >(其他)</span
                          >
                        </div>
                        <div class="idNo">
                          {{ item.idNoHide }}
                        </div>
                      </div>
                      <div class="eCardRight">
                        <div class="rightFristRow">
                          <img
                            class="redCrossImg"
                            src="../images/eCard-redCross.png"
                            alt=""
                          />
                          <div class="content">电子健康卡</div>
                        </div>
                        <div class="qrCodeBox">
                          <img
                            class="logoImg"
                            src="../images/eCard-qr-middle.png"
                            alt=""
                          />
                          <div class="qrCode" :id="'eCardqrcode' + item.id">
                            二维码
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="eCardSecondRow">
                      中华人民共和国卫生健康委员会监制
                    </div>
                  </div>
                </div>
              </div>
              <li>
                <span class="one-span">操作:</span>
                <span class="two-span">
                  <a
                    class="btn btn-blue"
                    @click="makeAnAppointmentRocord(item.hisId)"
                    >预约记录</a
                  >
                  <a
                    class="btn btn-blue"
                    @click="
                      cancelBind(item.id, item.relationshipCode, item.relation)
                    "
                    >解绑</a
                  >
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 就诊人管理 end -->

      <!-- 添加新的就诊人PC端 begin -->
      <a-modal
        title="添加新的就诊人"
        v-model="visiblePc"
        centered
        @cancel="closePcConsultantPeople"
        width="820px"
      >
        <template slot="footer">
          <a-button
            key="submit"
            type="primary"
            :loading="confirmLoading"
            @click="handleConsultantOk"
          >
            确认添加
          </a-button>
        </template>
        <div class="add-consultant-people-dialog">
          <ul>
            <li>
              <span class="one-span">姓名：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.name" class="width-220-px"
              /></span>
            </li>
            <li>
              <span class="one-span">证件类型：</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.idType"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in zjTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">证件号码：</span>
              <span class="two-span"
                ><a-input
                  @keyup="enterIdNo"
                  v-model="consultantForm.idNo"
                  :maxLength="30"
                  class="width-220-px"
              /></span>
            </li>
            <li>
              <span class="one-span">性别：</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.gender"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in genderList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">出生日期：</span>
              <span class="two-span">
                <a-date-picker
                  v-model="consultantForm.birthday"
                  valueFormat="YYYY-MM-DD"
                  class="width-220-px"
                  placeholder="请选择"
                  :disabled-date="pickerOptions"
                  :disabled="consultantForm.idType == '01'"
                />
              </span>
            </li>
            <li>
              <span class="one-span">民族：</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.nation"
                >
                  <a-select-option
                    :value="item.code"
                    v-for="(item, index) in nationList"
                    :key="item.code + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">手机号码：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.phone" class="width-220-px"
              /></span>
            </li>
            <li>
              <span class="one-span">验证码：</span>
              <span class="two-span"
                ><a-input
                  v-model="consultantForm.verifyCode"
                  class="width-220-px"
                /><span @click="getYzm" class="send-yzm">{{
                  yzmTxt
                }}</span></span
              >
            </li>
            <li>
              <span class="one-span">现地址：</span>
              <span class="two-span">
                <a-cascader v-model="consultantForm.region" :options="province" placeholder="请选择省市县" class="select width-220-px" />
              </span>
            </li>
            <li>
              <span class="one-span">详细地址：</span>
              <span class="two-span">
                <a-input v-model="consultantForm.address" class="width-220-px" />
              </span>
            </li>
            <li>
              <span class="one-span">与本人关系:</span>
              <span class="two-span">
                <a-select
                  class="select width-220-px"
                  v-model="consultantForm.relation"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in relationshipList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
          </ul>
          <AddPersonAgreement v-model="consultantForm.agreeCheck" :section="true" :sectiontips="true" :showpersonal="false" hospital="cd" />
          <AddPersonAgreement v-model="consultantForm.agree360Check" :showtips="false" :michref="mic.micUrl" hospital="cd" />
        </div>
      </a-modal>
      <!-- 添加新的就诊人PC端 end -->

      <!-- 添加新的就诊人手机端 begin -->
      <a-modal
        title="添加新的就诊人"
        v-model="visibleMobile"
        centered
        @cancel="closeMobileConsultantPeople"
        width="10rem"
      >
        <template slot="footer">
          <a-button
            key="submit"
            type="primary"
            :loading="confirmLoading"
            @click="handleConsultantOk"
          >
            确认添加
          </a-button>
        </template>
        <div class="add-consultant-people-mobile-dialog">
          <ul>
            <li>
              <span class="one-span">姓名：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.name" class=""
              /></span>
            </li>
            <li>
              <span class="one-span">证件类型：</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.idType">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in zjTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">证件号码：</span>
              <span class="two-span"
                ><a-input
                  @keyup="enterIdNo"
                  v-model="consultantForm.idNo"
                  :maxLength="30"
                  class=""
              /></span>
            </li>
            <li>
              <span class="one-span">性别：</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.gender">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in genderList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">出生日期：</span>
              <span class="two-span">
                <a-date-picker
                  v-model="consultantForm.birthday"
                  valueFormat="YYYY-MM-DD"
                  class="select"
                  placeholder="请选择"
                  :disabled-date="pickerOptions"
                  :disabled="consultantForm.idType == '01'"
                />
              </span>
            </li>
            <li>
              <span class="one-span">民族:</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.nation">
                  <a-select-option
                    :value="item.code"
                    v-for="(item, index) in nationList"
                    :key="item.code + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
            <li>
              <span class="one-span">手机号码：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.phone" class=""
              /></span>
            </li>
            <li>
              <span class="one-span">验证码：</span>
              <span class="two-span"
                ><a-input v-model="consultantForm.verifyCode" class="" /><span
                  @click="getYzm"
                  class="send-yzm"
                  >{{ yzmTxt }}</span
                ></span
              >
            </li>
            <li>
              <span class="one-span">现地址：</span>
              <span class="two-span">
                <a-cascader v-model="consultantForm.region" :options="province" placeholder="请选择省市县"  class="select"/>
              </span>
            </li>
            <li>
              <span class="one-span">详细地址：</span>
              <span class="two-span">
                <a-input v-model="consultantForm.address" />
              </span>
            </li>
            <li>
              <span class="one-span">与本人关系:</span>
              <span class="two-span">
                <a-select class="select" v-model="consultantForm.relation">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in relationshipList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </span>
            </li>
          </ul>
          <AddPersonAgreement v-model="consultantForm.agreeCheck" :section="true" :sectiontips="true" :showpersonal="false" hospital="cd" />
          <AddPersonAgreement v-model="consultantForm.agree360Check" :showtips="false" :michref="mic.micUrl" hospital="cd" />
        </div>
      </a-modal>
      <!-- 添加新的就诊人手机端 end -->

      <!-- 解除绑定弹窗 -->
      <a-modal title="" v-model="cbVisible" width="200px">
        <template slot="footer">
          <a-button key="submit" type="primary" @click="handleCbOk">
            是
          </a-button>
          <a-button key="back" type="primary" @click="handleCbCancel">
            否
          </a-button>
        </template>
        <p>是否确定解除绑定</p>
      </a-modal>

      <!-- 门诊预约 begin -->
      <div class="outpatient-appointment" v-if="activeBox == 4">
        <div v-if="!SCREEN.mobile">
          <div class="outpatient-people">
            <h2>门诊预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="outpatientPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span"
              >预约信息（{{ outpatientData.length }}条）</span
            >
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="outpatientColumns"
              :data-source="outpatientData"
              :pagination="false"
            >
              <template slot="action" slot-scope="text, record">
                <a class="btn btn-blue admb-5-px" v-if="record.payStatus == 0"
                  >预约成功</a
                >   
                <a class="btn btn-default" v-if="record.payStatus == 1"
                  >支付成功</a
                >
                <a class="btn btn-default" v-if="record.payStatus == 2"
                  >已取消</a
                >
                <a class="btn btn-default" v-if="record.payStatus == 3"
                  >已退号</a
                >
              </template>
              <template slot="operation" slot-scope="text, record">
                <a
                  @click="cancelSubscribe(record.orderCode)"
                  class="btn admb-5-px"
                  v-if="record.payStatus == 0"
                  >取消预约</a
                >
                <a
                  @click="goToPay(record)"
                  class="btn"
                  v-if="record.payStatus == 0"
                  >去支付</a
                >
                <a
                  @click="appointmentAgain()"
                  class="btn"
                  v-if="record.payStatus == 2"
                  >重新预约</a
                >
                <a
                  @click="returnNum(record.orderCode, record.visitId)"
                  class="btn"
                  v-if="record.payStatus == 1"
                  >退号</a
                >
              </template>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <div class="outpatient-mobile-people">
            <h2>门诊预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="outpatientPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span"
              >预约信息（{{ outpatientData.length }}条）</span
            >
          </div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in outpatientData" :key="item.id + index">
              <li>
                <span class="one-span">就诊科室:</span
                ><span class="two-span">{{ item.hisDeptName }}</span>
              </li>
              <li>
                <span class="one-span">医师:</span
                ><span class="two-span">{{ item.hisDoctorName }}</span>
              </li>
              <li>
                <span class="one-span">订单号:</span
                ><span class="two-span">{{ item.orderCode }}</span>
              </li>
              <li>
                <span class="one-span">预约时间:</span
                ><span class="two-span">{{ item.orderTime }}</span>
              </li>
              <li>
                <span class="one-span">状态:</span>
                <span class="two-span">
                  <a class="btn btn-blue" v-if="item.payStatus == 0"
                    >预约成功</a
                  >
                  <a class="btn btn-default" v-if="item.payStatus == 1"
                    >支付成功</a
                  >
                  <a class="btn btn-default" v-if="item.payStatus == 2"
                    >已取消</a
                  >
                  <a class="btn btn-default" v-if="item.payStatus == 3"
                    >已退号</a
                  >
                </span>
              </li>
              <li>
                <span class="one-span">操作:</span>
                <span class="two-span">
                  <a
                    @click="cancelSubscribe(item.orderCode)"
                    class="btn"
                    v-if="item.payStatus == 0"
                    >取消预约</a
                  >
                  <a
                    @click="goPaymentPhone(item)"
                    class="btn"
                    v-if="item.payStatus == 0"
                    >去支付</a
                  >
                  <a
                    @click="appointmentAgain()"
                    class="btn"
                    v-if="item.payStatus == 2"
                    >重新预约</a
                  >
                  <a
                    @click="returnNum(item.orderCode, item.visitId)"
                    class="btn"
                    v-if="item.payStatus == 1"
                    >退号</a
                  >
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 门诊预约 end -->

      <!-- 体检预约 begin -->
      <div class="medical-appointment" v-if="activeBox == 5">
        <div v-if="!SCREEN.mobile">
          <div class="outpatient-people">
            <h2>体检预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="medicalAppointmentPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span">预约信息（{{ medicalData.length }}条）</span>
          </div>
          <div class="table">
            <a-table
              class="a-table"
              :columns="medicalColumns"
              :data-source="medicalData"
              :pagination="false"
            >
              <template slot="packageInfoList" slot-scope="text, record">
                <span
                  v-for="(item, index) in record.packageInfoList"
                  :key="item.packageCode + index"
                >
                  {{ item.packageName }}
                </span>
              </template>
              <template slot="reserveStatus" slot-scope="text, record">
                <a
                  @click="
                    cancelMakeAnAppointment(
                      record.reserveId,
                      record.hisPatientId
                    )
                  "
                  class="btn"
                  v-if="record.payStatus == 1"
                  >取消预约</a
                >
                <a
                  @click="immediatelyPay(record)"
                  class="btn"
                  v-if="record.payStatus == 1"
                  >立即支付</a
                >
                <a
                  @click="goExamRefund(record)"
                  class="btn"
                  v-if="record.payStatus == 2 && record.reserveStatus == 1"
                  >退号</a
                >
                <!-- <a @click="makeAnAppointmentRocord(record.payStatus)" class="btn" v-if=" record.payStatus == 2 && record.reserveStatus == 1">预约记录</a> -->
                <a
                  class="btn btn-blue"
                  v-if="record.payStatus == 2 && record.reserveStatus == 2"
                  >登记</a
                >
                <a
                  class="btn btn-blue"
                  v-if="record.payStatus == 2 && record.reserveStatus == 3"
                  >检查</a
                >
                <a
                  @click="refreshMakeAnAppointment(record.payStatus)"
                  class="btn"
                  v-if="record.payStatus == 2 && record.reserveStatus == 4"
                  >重新预约</a
                >
                <a
                  @click="refreshMakeAnAppointment(record.payStatus)"
                  class="btn"
                  v-if="record.payStatus == 3 || record.payStatus == 4"
                  >重新预约</a
                >
              </template>
            </a-table>
          </div>
        </div>
        <div v-if="SCREEN.mobile">
          <div class="outpatient-mobile-people">
            <h2>体检预约</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="medicalAppointmentPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="two-span">预约信息（{{ medicalData.length }}条）</span>
          </div>
          <div class="table mobile-table">
            <ul v-for="(item, index) in medicalData" :key="item.id + index">
              <!-- <li><span class="one-span">体检科室:</span><span class="two-span">{{item.name}}</span></li> -->
              <li>
                <span class="one-span">体检套餐:</span>
                <span class="two-span">
                  <span
                    :title="subItem.packageName"
                    v-for="(subItem, subIndex) in item.packageInfoList"
                    :key="subItem.packageCode + subIndex"
                  >
                    {{ subItem.packageName }}
                  </span>
                </span>
              </li>
              <!-- <li><span class="one-span">体检等级:</span><span class="two-span">{{item.key}}</span></li> -->
              <li>
                <span class="one-span" style="width: 34%">预约体检时间:</span
                ><span class="two-span" style="width: 65%">{{
                  item.reserveDate
                }}</span>
              </li>
              <li>
                <span class="one-span">状态:</span>
                <span class="two-span">
                  <a
                    @click="
                      cancelMakeAnAppointment(item.reserveId, item.hisPatientId)
                    "
                    class="btn"
                    v-if="item.payStatus == 1"
                    >取消预约</a
                  >
                  <a
                    @click="goExamPaymentPhone(item)"
                    class="btn"
                    v-if="item.payStatus == 1"
                    >立即支付</a
                  >
                  <a
                    @click="goExamRefund(item)"
                    class="btn"
                    v-if="item.payStatus == 2 && item.reserveStatus == 1"
                    >退号</a
                  >
                  <!-- <a @click="makeAnAppointmentRocord(item.payStatus)" class="btn" v-if=" item.payStatus == 2 && item.reserveStatus == 1">预约记录</a> -->
                  <a
                    class="btn btn-blue"
                    v-if="item.payStatus == 2 && item.reserveStatus == 2"
                    >登记</a
                  >
                  <a
                    class="btn btn-blue"
                    v-if="item.payStatus == 2 && item.reserveStatus == 3"
                    >检查</a
                  >
                  <a
                    @click="refreshMakeAnAppointment(item.payStatus)"
                    class="btn"
                    v-if="item.payStatus == 2 && item.reserveStatus == 4"
                    >重新预约</a
                  >
                  <a
                    @click="refreshMakeAnAppointment(item.payStatus)"
                    class="btn"
                    v-if="item.payStatus == 3 || item.payStatus == 4"
                    >重新预约</a
                  >
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 体检预约 end -->

      <!-- 报告查询 begin -->
      <div class="report-query" v-if="activeBox == 6">
        <div v-if="!SCREEN.mobile">
          <div v-if="showReport == 1">
            <div class="report-title-box">
              <span class="report-title">报告查询</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="report-main-box">
              <div class="type-box">
                <span class="type-span">类型：</span>
                <a-select class="select" v-model="activeReportType">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in reportTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
              <!-- <div class="time-box">
                <span class="time-span">时间：</span>
                <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
                <span class="to">至</span>
                <a-date-picker class="time-picker" @change="onReportTimeTwoChange" />
              </div> -->
              <div class="search-box">
                <span class="btn-box" @click="searchReportOne">
                  <img src="../images/presentation-img9.png" alt="" />
                  <span class="search-span">查询</span>
                </span>
              </div>
              <div class="report-tab">
                <div class="report-tab-head">
                  <p
                    :class="{ active: reportTypeTab == 1 }"
                    @click="reportTypeTab = 1"
                  >
                    <img src="../images/presentationpage1-img1.png" alt="" />
                    <span class="text">检验报告</span>
                    <span v-if="reportTypeTab == 1" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 2 }"
                    @click="reportTypeTab = 2"
                  >
                    <img src="../images/presentationpage1-img2.png" alt="" />
                    <span class="text">检查报告</span>
                    <span v-if="reportTypeTab == 2" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 3 }"
                    @click="reportTypeTab = 3"
                  >
                    <img src="../images/presentationpage1-img3.png" alt="" />
                    <span class="text">体检报告</span>
                    <span v-if="reportTypeTab == 3" class="triangle"></span>
                  </p>
                </div>
                <div class="report-tab-body">
                  {{ txt }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="showReport == 2">
            <div class="report-title-box">
              <span class="report-title">查询结果</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="search-two-box">
              <span class="type-span">类型：</span>
              <a-select class="select" v-model="activeReportType">
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in reportTypeList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <!-- <span class="time-span">时间：</span>
              <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
              <span class="to">至</span>
              <a-date-picker class="time-picker" @change="onReportTimeTwoChange" /> -->
              <span @click="searchReportTwo" class="search-btn">查询</span>
            </div>
            <div class="table" v-if="activeReportType != '03'">
              <a-table
                class="a-table"
                :columns="reportOneColumns"
                :data-source="reportOneData"
                :pagination="false"
              >
                <template slot="action" slot-scope="text, record">
                  <a @click="reviewReport(record.filePath)" class="btn">预览</a>
                  <a class="btn" v-if="false">下载</a>
                </template>
              </a-table>
            </div>
            <div class="table" v-if="activeReportType == '03'">
              <a-table
                class="a-table"
                :columns="reportTwoColumns"
                :data-source="reportTwoData"
                :pagination="false"
              >
                <template slot="action" slot-scope="text, record">
                  <a @click="reviewReport(record.filePath)" class="btn">预览</a>
                  <a class="btn" v-if="false">下载</a>
                </template>
              </a-table>
            </div>
          </div>
        </div>

        <div v-if="SCREEN.mobile">
          <div v-if="showReport == 1">
            <div class="report-title-box">
              <span class="report-title">报告查询</span>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="report-main-box">
              <div class="type-box">
                <span class="type-span">类型：</span>
                <a-select class="select" v-model="activeReportType">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in reportTypeList"
                    :key="item.id + index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
              <!-- <div class="time-box">
                <span class="time-span">时间：</span>
                <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
                <span class="to">至</span>
                <a-date-picker class="time-picker" @change="onReportTimeTwoChange" />
              </div> -->
              <div class="search-box">
                <span class="btn-box" @click="searchReportOne">
                  <img src="../images/presentation-img9.png" alt="" />
                  <span class="search-span">查询</span>
                </span>
              </div>
              <div class="report-tab">
                <div class="report-tab-head">
                  <p
                    :class="{ active: reportTypeTab == 1 }"
                    @click="reportTypeTab = 1"
                  >
                    <img src="../images/presentationpage1-img1.png" alt="" />
                    <span class="text">检验报告</span>
                    <span v-if="reportTypeTab == 1" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 2 }"
                    @click="reportTypeTab = 2"
                  >
                    <img src="../images/presentationpage1-img2.png" alt="" />
                    <span class="text">检查报告</span>
                    <span v-if="reportTypeTab == 2" class="triangle"></span>
                  </p>
                  <p
                    :class="{ active: reportTypeTab == 3 }"
                    @click="reportTypeTab = 3"
                  >
                    <img src="../images/presentationpage1-img3.png" alt="" />
                    <span class="text">体检报告</span>
                    <span v-if="reportTypeTab == 3" class="triangle"></span>
                  </p>
                </div>
                <div class="report-tab-body">
                  {{ txt }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="showReport == 2">
            <div class="report-two-title-box">
              <h2 class="report-title">查询结果</h2>
              <a-select
                v-model="activeHisPatientId"
                class="select"
                @change="reportConsultantPeopleChange"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in consultantPeopleList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <div class="search-three-box">
              <span class="type-span">类型：</span>
              <a-select class="select" v-model="activeReportType">
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in reportTypeList"
                  :key="item.id + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </div>
            <!-- <div class="search-four-box">
              <span class="time-span">时间：</span>
              <a-date-picker class="time-picker" @change="onReportTimeOneChange" />
              <span class="to">至</span>
              <a-date-picker class="time-picker" @change="onReportTimeTwoChange" />
            </div> -->
            <div @click="searchReportTwo" class="search-btn-box">查询</div>
            <div class="line"></div>
            <div class="table mobile-table" v-if="activeReportType != '03'">
              <ul
                v-for="(item, index) in reportOneData"
                :key="item.reportDate + index"
              >
                <li>
                  <span class="one-span">名称:</span
                  ><span class="two-span">{{ item.fileName }}</span>
                </li>
                <li>
                  <span class="one-span">科室名称:</span
                  ><span class="two-span">{{ item.hisDeptName }}</span>
                </li>
                <li>
                  <span class="one-span">操作:</span
                  ><span class="two-span"
                    ><a @click="reviewReport(item.filePath)" class="btn"
                      >预览</a
                    ></span
                  >
                </li>
              </ul>
            </div>
            <div class="table mobile-table" v-if="activeReportType == '03'">
              <ul
                v-for="(item, index) in reportTwoData"
                :key="item.reportDate + index"
              >
                <li>
                  <span class="one-span">名称:</span
                  ><span class="two-span">{{ item.packageName }}</span>
                </li>
                <li>
                  <span class="one-span">姓名:</span
                  ><span class="two-span">{{ item.hisPatientName }}</span>
                </li>
                <li>
                  <span class="one-span">操作:</span
                  ><span class="two-span"
                    ><a @click="reviewReport(item.filePath)" class="btn"
                      >预览</a
                    ></span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 报告查询 end -->

      <!-- 消费明细 begin -->
      <div class="statement" v-if="activeBox == 7">
        <div v-if="!SCREEN.mobile">
          <div class="title-box">
            <span class="consumption-span">消费明细</span>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="statementConsultantPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-box">
            <span
              class="one-span"
              @click="getSevenChild(1)"
              :class="{ active: showChildTab == 1 }"
              >在院日清明细</span
            >
            <span
              class="two-span"
              @click="getSevenChild(2)"
              :class="{ active: showChildTab == 2 }"
              >已缴费记录</span
            >
            <span class="three-span">时间：</span>
            <a-date-picker
              class="time-picker"
              v-model="startDate"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择"
            />
            <!-- <span class="to">至</span>
            <a-date-picker class="time-picker" v-model="endDate" valueFormat="YYYY-MM-DD"  placeholder="请选择"/> -->
            <span class="five-span" @click="searchConsume">查询</span>
          </div>
          <div class="table-box">
            <div class="table-one-tab" v-if="showChildTab == 1">
              <a-table
                class="a-table"
                :columns="statementColumnsOne"
                :data-source="statementDataOne"
                :pagination="false"
              >
              </a-table>
            </div>
            <div class="table-two-tab" v-if="showChildTab == 2">
              <a-table
                class="a-table"
                :columns="statementColumnsTwo"
                :data-source="statementDataTwo"
                :pagination="pagination"
              >
              </a-table>
            </div>
          </div>
        </div>

        <div v-if="SCREEN.mobile">
          <div class="title-box">
            <h2 class="consumption-h2">消费明细</h2>
            <a-select
              v-model="activeHisPatientId"
              class="select"
              @change="statementConsultantPeopleChange"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in consultantPeopleList"
                :key="item.id + index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="search-box-one">
            <span
              class="one-span"
              @click="getSevenChild(1)"
              :class="{ active: showChildTab == 1 }"
              >在院日清明细</span
            >
            <span
              class="one-span"
              @click="getSevenChild(2)"
              :class="{ active: showChildTab == 2 }"
              >已缴费记录</span
            >
          </div>
          <div class="search-box-two">
            <span class="three-span">时间：</span>
            <a-date-picker
              class="time-picker"
              v-model="startDate"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择"
            />
            <!-- <span class="to">至</span>
            <a-date-picker class="time-picker" v-model="endDate" valueFormat="YYYY-MM-DD"  placeholder="请选择"/> -->
            <div class="search-div" @click="searchConsume">查询</div>
          </div>
          <div class="table mobile-table">
            <div class="table-one-tab" v-if="showChildTab == 1">
              <ul
                v-for="(item, index) in statementDataOne"
                :key="item.patientNo + index"
              >
                <li>
                  <span class="one-span">病人费别:</span
                  ><span class="two-span">{{ item.feeType }}</span>
                </li>
                <li>
                  <span class="one-span">科室:</span
                  ><span class="two-span">{{ item.dept }}</span>
                </li>
                <li>
                  <span class="one-span">病区:</span
                  ><span class="two-span">{{ item.ward }}</span>
                </li>
                <li>
                  <span class="one-span">总费用:</span
                  ><span class="two-span">{{ item.totalFee }}</span>
                </li>
                <li>
                  <span class="one-span">当日总计:</span
                  ><span class="two-span"> {{ item.todayFee }}</span>
                </li>
                <li>
                  <span class="one-span">余额:</span
                  ><span class="two-span"> {{ item.balance }}</span>
                </li>
              </ul>
            </div>
            <div class="table-two-tab" v-if="showChildTab == 2">
              <ul
                v-for="(item, index) in statementDataTwo"
                :key="item.visitId + index"
              >
                <li>
                  <span class="one-span">票据流水号:</span
                  ><span class="two-span">{{ item.name }}</span>
                </li>
                <!-- <li><span class="one-span">消费日期:</span><span class="two-span">{{item.name}}</span></li> -->
                <li>
                  <span class="one-span">票据总金额:</span
                  ><span class="two-span">{{ item.totalFee }}</span>
                </li>
                <li>
                  <span class="one-span">就诊日期:</span
                  ><span class="two-span">{{ item.regDate }}</span>
                </li>
                <li>
                  <span class="one-span">就诊科室:</span
                  ><span class="two-span">{{ item.deptName }}</span>
                </li>
                <li>
                  <span class="one-span">就诊医生:</span
                  ><span class="two-span">{{ item.docName }}</span>
                </li>
              </ul>
              <a-pagination
                @change="pageChange"
                :current="pagination.current"
                :pageSize="10"
                :total="pagination.total"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 消费明细 end -->
    </div>

    <a-modal
      v-model="cancelSubscribeVisible"
      title="提示"
      @ok="handleCancelSubscribeOk"
      okText="确定"
      cancelText="取消"
    >
      <div>
        是否取消预约？
      </div>
    </a-modal>

    <a-modal
      v-model="returnNumVisible"
      title="提示"
      @ok="handleReturnNumOk"
      okText="确定"
      cancelText="取消"
    >
      <div>
        是否退号？
      </div>
    </a-modal>

    <a-modal
      v-model="cancelMakeAnAppointmentVisible"
      title="提示"
      @ok="handleCancelMakeAnAppointmentOk"
      okText="确定"
      cancelText="取消"
    >
      <div>
        是否取消预约？
      </div>
    </a-modal>

    <!-- 支付弹窗 begin -->
    <div class="wemsk" v-show="paymentVisible"></div>
    <div class="pay-model-box" v-show="paymentVisible">
      <div class="pay-main-box">
        <div class="title">
          <div v-if="radioValue == 1" class="top-title">
            挂号成功<span class="close-span" @click="closePaymentModal">x</span>
          </div>
          <div v-if="radioValue == 2" class="top-title">
            预约成功<span class="close-span" @click="closePaymentModal">x</span>
          </div>
          <div v-if="radioValue == 1" class="two-box">
            您预约的{{
              paymentRecord.hisDeptName + paymentRecord.hisDoctorName + "医生"
            }}<span>{{ paymentRecord.orderTime }}</span
            >挂号成功
          </div>
          <div v-if="radioValue == 2" class="two-box">
            您预约的<span>{{ examBookTime }}</span
            >{{ examBooKMail }}预约成功
          </div>
          <div class="three-box">
            请于<span>30分钟</span>内完成支付，如在有效期内未完成支付，将自动为您取消预约
          </div>
        </div>
        <div class="pay-money">
          应付金额：<span>{{ paymentRecord.fee }}</span
          >元
        </div>
        <div class="img-box">
          <div class="left-img-box">
            <div class="qrcode-box">
              <div id="qrcode"></div>
            </div>
            <div class="bottom-remind-box">
              <img class="img" src="../images/sm.png" alt="" />
              <div class="txt">请使用微信、支付宝<br />扫码支付</div>
            </div>
          </div>
          <div class="right-img-box">
            <img src="../images/payBg.png" alt="" />
          </div>
        </div>
        <div class="red-txt-box">
          <div class="content-red-box">
            <img src="../images/gth.png" alt="" />
            距离二维码过期还剩<span>{{ num }}</span
            >秒，过期后请重新获取二维码
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹窗 end -->

    <!-- 支付成功弹窗 begin -->
    <div class="wemsk" v-show="paySuccessVisible"></div>
    <div class="pay-success-model-box" v-show="paySuccessVisible">
      <div class="top-title">
        支付成功<span class="close-span" @click="closePaySuccessModel">x</span>
      </div>
      <div class="middle-box">
        <img src="../images/success.png" alt="" />
        您已成功付款<span>{{ paymentFee }}</span
        >元
      </div>
      <div class="bottom-box">
        <span>{{ paySuccessNum }}</span
        >s后自动关闭
      </div>
    </div>
    <!-- 支付成功弹窗 end -->

    <!-- 手机支付中弹框 -->
    <div v-if="payPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">
          支付中<span class="close-span" @click="closePayPhoneModal">x</span>
        </div>
        <div class="middle-box">
          <!-- <img src="../images/success.png" alt=""> -->
          请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约
        </div>
        <div class="bottom-box">
          <span>{{ num }}</span
          >s后自动关闭，请重新获取支付链接
        </div>
      </div>
    </div>

    <!-- 是否支付完成弹窗begin -->
    <div class="wemsk" v-if="showHasPaySuccess"></div>
    <div class="has-pay-success" v-if="showHasPaySuccess">
      <div class="gth-box">
        <div class="gth">
          !
        </div>
      </div>
      <div class="txt">请确认是否支付完成</div>
      <div class="btn-box">
        <p @click="refreshPay">重新支付</p>
        <p class="red-btn" @click="hasPaySuccess">已完成支付</p>
      </div>
    </div>
    <!-- 是否支付完成弹窗end -->

    <div class="iframe-box" v-if="showIframe">
      <span class="close-span" @click="showIframe = false">X</span>
      <iframe
        width="100%"
        height="100%"
        :src="iframeSrc"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { JSEncrypt } from "jsencrypt";
import moment from "moment";
import { MIC_CONFIG } from "@/utils/constant";
import AddPersonAgreement from "@/components/hospitalPersonalList/addPersonAgreement"
import{ encryptByDES, checkIdNo, checkPhoneNo, checkIdTypes } from '@/utils/index';

const consultantColumns = [
  {
    title: "姓名",
    dataIndex: "name",
    width: "10%",
  },
  {
    title: "诊疗卡号",
    dataIndex: "cardNo",
    width: "15%",
  },
  {
    title: "证件号",
    dataIndex: "idNoHide",
    width: "20%",
  },
  {
    title: "手机号",
    dataIndex: "phone",
    width: "15%",
  },
  {
    title: "关系",
    dataIndex: "relationshipCode",
    width: "10%",
    scopedSlots: { customRender: "relationshipCode" },
  },
  // {
  //   title: '电子健康卡',
  //   dataIndex: 'eCard',
  //   width: '70%',
  //   scopedSlots: { customRender: 'eCard' },
  // },
  {
    title: "操作",
    dataIndex: "action",
    width: "15%",
    scopedSlots: { customRender: "action" },
  },
];
const consultantECardColumns = [
  {
    title: "电子健康卡",
    dataIndex: "eCard",
    width: "70%",
    scopedSlots: { customRender: "eCard" },
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "15%",
    scopedSlots: { customRender: "action" },
  },
];
let consultantData = [];
const outpatientColumns = [
  {
    title: "就诊科室",
    dataIndex: "hisDeptName",
    width: "10%",
  },
  {
    title: "医师",
    dataIndex: "hisDoctorName",
    width: "7%",
  },
  {
    title: "订单号",
    dataIndex: "orderCode",
    width: "16%",
  },
  {
    title: "预约时间",
    dataIndex: "orderTime",
    width: "15%",
  },
  {
    title: "状态",
    dataIndex: "action",
    width: "10%",
    scopedSlots: { customRender: "action" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    width: "15%",
    scopedSlots: { customRender: "operation" },
  },
];
let outpatientData = [];
const medicalColumns = [
  {
    title: "体检套餐",
    dataIndex: "packageInfoList",
    width: "15%",
    scopedSlots: { customRender: "packageInfoList" },
  },
  {
    title: "预约体检时间",
    dataIndex: "reserveDate",
    width: "25%",
  },
  {
    title: "状态",
    dataIndex: "reserveStatus",
    width: "20%",
    scopedSlots: { customRender: "reserveStatus" },
  },
];
let medicalData = [];
const reportOneColumns = [
  {
    title: "名称",
    dataIndex: "fileName",
    width: "20%",
  },
  {
    title: "科室名称",
    dataIndex: "hisDeptName",
    width: "15%",
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "15%",
    scopedSlots: { customRender: "action" },
  },
];
const reportTwoColumns = [
  {
    title: "名称",
    dataIndex: "examTitle",
    width: "15%",
  },
  {
    title: "科室",
    dataIndex: "hisDeptName",
    width: "15%",
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "20%",
    scopedSlots: { customRender: "action" },
  },
];
let reportOneData = [];
let reportTwoData = [];
const statementColumnsOne = [
  {
    title: "病人费别",
    dataIndex: "feeType",
    width: "15%",
  },
  {
    title: "科室",
    dataIndex: "dept",
    width: "15%",
  },
  {
    title: "病区",
    dataIndex: "ward",
    width: "15%",
  },
  {
    title: "总费用",
    dataIndex: "totalFee",
    width: "15%",
  },
  {
    title: "当日总计",
    dataIndex: "todayFee",
    width: "15%",
  },
  {
    title: "余额",
    dataIndex: "balance",
    width: "15%",
  },
];
let statementDataOne = [];
const statementColumnsTwo = [
  {
    title: "票据流水号",
    dataIndex: "dealSeq",
    width: "15%",
  },
  // {
  //   title: '消费日期',
  //   dataIndex: 'regDate',
  //   width: '15%',
  // },
  {
    title: "票据总金额",
    dataIndex: "totalFee",
    width: "15%",
  },
  {
    title: "就诊日期",
    dataIndex: "regDate",
    width: "15%",
  },
  {
    title: "就诊科室",
    dataIndex: "deptName",
    width: "15%",
  },
  {
    title: "就诊医生",
    dataIndex: "docName",
    width: "15%",
  },
];
let statementDataTwo = [];
let consultantForm = {
  sys: "ohealth",
  hospitalCode: "H05",
  name: "",
  phone: "",
  idType: "01",
  idNo: "",
  birthday: "",
  gender: "1",
  relation: "0",
  verifyCode: "",
  source: "web",
  nation: "01",
  agreeCheck: false,
  agree360Check: false,
  region: [],
  address: '',
};
export default {
  name: "personlist-001",
  components: {
    AddPersonAgreement,
  },
  data() {
    return Object.assign({
      consultantData,
      consultantColumns,
      consultantECardColumns,
      outpatientData,
      outpatientColumns,
      medicalData,
      medicalColumns,
      reportOneColumns,
      reportTwoColumns,
      reportOneData,
      reportTwoData,
      statementDataOne,
      statementColumnsOne,
      statementDataTwo,
      statementColumnsTwo,
      activeBox: 3,
      showChildTab: 1,
      showReport: 1,
      visiblePc: false,
      confirmLoading: false,
      // zjTypeList: [
      //   {
      //     id: "01",
      //     name: "居民身份证",
      //   },
      //   {
      //     id: "03",
      //     name: "护照",
      //   },
      //   {
      //     id: "06",
      //     name: "港澳居民来往内地通行证",
      //   },
      //   {
      //     id: "07",
      //     name: "台湾居民来往内地通行证",
      //   },
      // ],
      zjTypeList: [
        { id: '01', name: '居民身份证' },
        { id: '02', name: '户口簿' },
        { id: '07', name: '护照' },
        { id: '08', name: '港澳居民来往内地通行证' },
        { id: '10', name: '台湾居民来往大陆通行证' },
        // { id: '12', name: '港澳台湾居民居住证' },
        { id: '15', name: '外国人永久居留身份证' },
      ],
      activeZjType: "01",
      genderList: [
        {
          name: "男",
          id: "1",
        },
        {
          name: "女",
          id: "2",
        },
      ],
      activeGender: "1",
      relationshipList: [
        {
          id: "0",
          name: "本人",
        },
        {
          id: "1",
          name: "子女",
        },
        {
          id: "2",
          name: "父母",
        },
        {
          id: "3",
          name: "夫妻",
        },
        {
          id: "4",
          name: "其它",
        },
      ],
      publicKey: "",
      activeRelationship: "0",
      visibleMobile: false,
      cbVisible: false,
      reportTypeList: [
        {
          id: "01",
          name: "检验报告",
        },
        {
          id: "02",
          name: "检查报告",
        },
        {
          id: "03",
          name: "体检报告",
        },
      ],
      activeReportType: "01",
      txt:
        "医院数字化涵盖数字化医疗、数字化运营、数字化营销、数字化服务四大核心业务模块，其中数字化医疗技术极大的突破了时间与空间的界限，大大增强了患者与医院之间的联接，无论是在家中，还是在工作场所都可以随时        随地与医院建立联系，提高了医疗服务的可及性与便利性，为医务人员诊疗活动提供高效的技术与流程支撑",
      activeTab: 3,
      consultantForm,
      activeCancelPeople: {
        // 当前解绑人信息
        id: 0, // 当前解绑人id
        relationshipCode: 0, // 当前解绑人relationshipCode
        relation: "", // 当前解绑人relation
        hospitalCode: "H05",
      },
      activeHisPatientId: "0",
      reportForm: {},
      consultantPeopleList: [],
      patientListDemo: [
        {
          birthday: "1994-01-14",
          cardNo: "0000109600",
          cardType: "01",
          createTime: "2021-04-16 14:34:13",
          ehealthCardId: "",
          ehealthCode:
            "12345678asfafdgko,isaxddcqwqcsmjkadw@^cas*mcdms$djskajdiw111",
          gender: "1",
          hisId: "0003016710",
          hospitalCode: "H05",
          id: 1006,
          idNo: "5113**********5158",
          idType: "01",
          name: "饶勇军",
          phone: "18215574627",
          relation: "0",
          relationshipCode: "0",
          userId: 60023276575,
        },
        {
          birthday: "2021-04-15",
          cardNo: "0000109604",
          cardType: "01",
          createTime: "2021-04-16 14:41:34",
          ehealthCardId: "222",
          ehealthCode:
            "12345678asfafdgko,isaxddcqwqcsmjkadw@^cas*mcdms$djskajdiw222",
          gender: "2",
          hisId: "0030172948",
          hospitalCode: "H05",
          id: 1007,
          idNo: "5113**********5157",
          idType: "01",
          name: "公司",
          phone: "18215574627",
          relation: "2",
          relationshipCode: "2",
          userId: 60023276575,
        },
        {
          birthday: "2021-04-15",
          cardNo: "0000109604",
          cardType: "01",
          createTime: "2021-04-16 14:41:34",
          ehealthCardId: "",
          ehealthCode:
            "12345678asfafdgko,isaxddcqwqcsmjkadw@^cas*mcdms$djskajdiw333",
          gender: "2",
          hisId: "0030172948",
          hospitalCode: "H05",
          id: 1008,
          idNo: "5113**********5166",
          idType: "01",
          name: "公司2",
          phone: "18215574627",
          relation: "3",
          relationshipCode: "3",
          userId: 60023276575,
        },
      ],
      cancelSubscribeVisible: false,
      cancelSubscribeOrderCode: "",
      returnNumVisible: false,
      returnNumVisited: "",
      returnNumOrderCode: "",
      activeReportVisitId: "",
      cancelMakeAnAppointmentVisible: false,
      cancelMakeAnAppointmentReserveId: "",
      cancelMakeAnAppointmentHisPatientId: "",
      reportTypeTab: 1,
      startDate: moment(new Date()).format("YYYY-MM-DD"),
      endDate: moment(new Date()).format("YYYY-MM-DD"),
      pagination: {
        // 已缴费记录分页设置
        current: 1,
        pageSize: 10,
        change: this.pageChange,
        total: 0,
      },
      iframeSrc: "",
      showIframe: false,

      paymentVisible: false, // 显示支付弹框
      paymentQrCode: "", // 二维码显示链接
      paymentRecord: {
        // 一条数据信息
        hisDeptName: "",
        hisDoctorName: "",
        orderTime: "",
        fee: "",
        orderCode: "",
      },
      timer: "", // 定时器
      num: 60, // 时长
      showPayModel: false,
      showPaySuccessModel: false,
      paymentFee: "", // 支付金额
      paySuccessNum: 5, // 支付成功展示时间
      radioValue: 1, // 1门诊预约，2体检预约
      payPhoneVisible: false, // 手机支付弹框显示
      mineInfo: {}, //本人的信息
      hospitalCode: "H05",
      paySuccessTimer: "", // 支付成功计时器
      paySuccessVisible: false, // 显示支付成功
      examBooKMail: "", // 体检预约套餐
      examBookTime: "", // 体检预约时间
      showHasPaySuccess: false, // 手机端是否支付完成
      yzmTxt: "获取验证码", // 获取验证码内容
      yzmNum: 120, // 验证码倒计时
      yzmTimer: null, // 验证码计时器
      isShowMzFeeDialog: true, // 门诊支付是否可以点击计费弹窗
      isShowTjFeeDialog: true, // 体检支付是否可以点击计费弹窗

      nationList: [], // 民族选项
      ehealthCardFlag: false, // 标记显示就诊人或电子健康卡 false 显示就诊人列表；true 显示电子健康卡
      // 360健康视图
      mic: {},
      province: [], // 省市县
    });
  },
  created() {
    this.getPublicKey();
    // this.consultantData = this.patientListDemo;
    let callback=null
    this.getNationList();
    let href = this.$route.hash;
    if(href.indexOf("#")>-1){
      let index = href.split("#")[1];
      const fun = ()=>{ this.changeTab(index)}
      callback=index < 8 && fun
    }
    this.getConsultantList(callback)
  },
  mounted() {
    this.getMicUsing() // 360个人知情同意书-当前再用信息
    this.getProvincesList() // 获取省市县

    // if(this.consultantData.length>0){
    //   let that=this;
    //   let eCardFlag = true;
    //   this.consultantData.forEach((item,i)=>{
    //     if(item.ehealthCardId==undefined || item.ehealthCardId==null || item.ehealthCardId==""){
    //       eCardFlag = false;
    //     }
    //   })
    //   if(eCardFlag){
    //     this.ehealthCardFlag = true;
    //   }else{
    //     this.$warning({
    //       content: '本院就诊卡已全面升级为电子健康卡',
    //       okText: '确认升级',
    //       onOk() {
    //         that.updateEHealthCard()
    //       },
    //       // onCancel() {},
    //     });
    //     // this.updateEHealthCard();
    //     return
    //   }
    // }
    // setTimeout(()=>{
    //   this.consultantData.forEach((item,i)=>{
    //     this.getECardQrCode(item.id,item.ehealthCode);
    //   })
    // },1000)
  },
  methods: {
    pickerOptions(current) {
      return current && (current.valueOf() < new Date('1900', '0', '1').getTime()) || (current.valueOf() > new Date().getTime());
    },
    getPublicKey() {
      this.$API.rsaPublic().then((res) => {
        if (res.code == 0) {
          this.publicKey = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取就诊人再获取门诊预约列表
    getConsultantList1() {
      let data = { hospitalCode: "H05" };
      this.$API.patientList(data).then((res) => {
        if (res.code == 0) {
          this.consultantData = res.data || [];
          if (this.consultantData.length > 0) {
            this.activeHisPatientId = this.consultantData[0].hisId;
            this.getOutpatientBookList();
          } else {
            this.activeHisPatientId = 0;
            this.getOutpatientBookList();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取就诊人再获取体检预约列表
    getConsultantList2() {
      let data = { hospitalCode: "H05" };
      this.$API.patientList(data).then((res) => {
        if (res.code == 0) {
          this.consultantData = res.data || [];
          if (this.consultantData.length > 0) {
            this.activeHisPatientId = this.consultantData[0].hisId;
            this.getExamBookList();
          } else {
            this.activeHisPatientId = 0;
            this.getExamBookList();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取就诊人列表
    getConsultantList(callback) {
      let ut = localStorage.getItem("ut");
      // localStorage中没有ut，判断是否登录
      if (ut == undefined || ut == null || ut == "") {
        this.$router.push({
          path: "/personalCenter/login",
          query: { redirect: "/personalCenter/personalList" }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
        return;
      }
      let data = { hospitalCode: "H05" };
      this.$API.patientList(data).then((res) => {
        if (res.code == 0) {
          this.consultantData = res.data || [];
          // 判断是否变更电子健康卡（20210719）
          if (this.consultantData.length > 0) {
            let that = this;
            let eCardFlag = true;
            this.consultantData.forEach((item, i) => {
              if (
                item.ehealthCardId == undefined ||
                item.ehealthCardId == null ||
                item.ehealthCardId == ""
              ) {
                eCardFlag = false;
              }
            });
            if (eCardFlag) {
              this.ehealthCardFlag = true;
            } else {
              this.$warning({
                content: "本院就诊卡已全面升级为电子健康卡",
                okText: "确认升级",
                onOk() {
                  that.updateEHealthCard();
                },
              });
              return;
            }
          }
          if (this.consultantData.length > 0) {
            this.activeHisPatientId = this.consultantData[0].hisId;
            callback&&callback()
          } else {
            this.activeHisPatientId = 0;
          }
          this.consultantPeopleList = [];
          for (let i = 0; i < this.consultantData.length; i++) {
            let obj = {
              id: this.consultantData[i].hisId,
              name: this.consultantData[i].name,
            };
            this.consultantPeopleList.push(obj);
            // 判断是否是本人
            if (this.consultantData[i].relationshipCode == "0") {
              this.mineInfo = this.consultantData[i];
            }
          }
          // 循环调用生成二维码
          this.$nextTick(() => {
            this.consultantData.forEach((item, i) => {
              this.getECardQrCode(item.id, item.ehealthCode);
            });
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 生成电子健康卡二维码
    getECardQrCode(id, ehealthCode) {
      if(!document.getElementById("eCardqrcode" + id)){
        return
      }
      let that = this;
      // let ehealthCode = "12345678asfafdgko,isaxddcqwqcsmjkadw@^cas*mcdms$djskajdiw"
      let width = 98;
      let height = 98;
      console.log("this inside getECardQrCode:");
      let qrcode = require("qrcodejs2");
      document.getElementById("eCardqrcode" + id).innerHTML = "";
      console.log("this inside getECardQrCode 123");
      if (that.SCREEN.mobile) {
        width = 78;
        height = 78;
      }
      new qrcode(document.getElementById("eCardqrcode" + id), {
        text: ehealthCode,
        width: width,
        height: height,
        correctLevel: qrcode.CorrectLevel.Q,
        src: "../images/eCard-qr-middle.png",
        logoWidth: 21,
        logoHeight: 21,
      });
      console.log("this inside getECardQrCode 456");
    },
    // 更新电子健康卡
    updateEHealthCard() {
      var ids = [];
      this.consultantData.forEach((item) => {
        if (
          item.ehealthCardId == undefined ||
          item.ehealthCardId == null ||
          item.ehealthCardId == ""
        ) {
          ids.push(item.id);
        }
      });
      console.log("updateEHealthCard ids:", ids);
      let params = {
        ids: ids,
      };
      this.$API.updateEHealthCard(params).then((res) => {
        if (res && res.code == 0) {
          console.log("updateEHealthCard res:", res);
          this.$message.success("更新成功！");
          this.getConsultantList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取民族列表
    getNationList() {
      this.$API.getNationList().then((res) => {
        if (res && res.code == 0) {
          console.log("getNationList res:", res);
          this.nationList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPublicKey(this.publicKey);
      return jsencrypt.encrypt(msg);
    },
    // 获取验证码
    getYzm() {
      debugger;
      if (!this.consultantForm.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (this.yzmTxt != "获取验证码") {
        return;
      }
      this.yzmTimer = setInterval(() => {
        this.yzmTxt = this.yzmNum + "s";
        this.yzmNum--;
        if (this.yzmNum <= 0) {
          this.yzmNum = 120;
          this.yzmTxt = "获取验证码";
          clearInterval(this.yzmTimer);
        }
      }, 1000);
      // let obj = {
      //   phone: this.consultantForm.phone,
      //   language: "zh",
      //   purpose: "V",
      //   sys: "ohealth",
      //   templateNo: "h05-website",
      // };
      let phone = this.setEncrypt(this.consultantForm.phone);
      let language = this.setEncrypt("zh");
      let purpose = this.setEncrypt("V");
      let sys = this.setEncrypt("ohealth"); //合肥sys传h02site,苏州成都传ohealth
      let templateNo = this.setEncrypt("h05-website");
      let hospitalCode = this.setEncrypt("H05");
      let obj = {
        phone: phone,
        language: language,
        purpose: purpose,
        sys: sys,
        templateNo: templateNo,
        hospitalCode: hospitalCode,
      };
      debugger;
      this.$API.sendCode(obj).then((res) => {
        if (res.code == 0) {
          this.$message.success("获取验证码成功！");
        } else {
          this.$message.error(res.msg);
          this.yzmNum = 120;
          this.yzmTxt = "获取验证码";
          clearInterval(this.yzmTimer);
        }
      });
    },
    // 获取门诊预约记录列表
    getOutpatientBookList() {
      // if (this.activeHisPatientId == 0) {
      //   this.$message.warning("无门诊预约记录");
      //   return;
      // }
      // HisPatientId加密
      const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      const encodeEnDes = window.encodeURIComponent(enDes)
      let data = {
        hospitalCode: "H05",
        hisPatientId: encodeEnDes,
        // hisPatientId:'0030209889',
        pageNo: 1,
        pageSize: 100,
      };
      this.$API.bookList(data).then((res) => {
        if (res.code == 0) {
          this.outpatientData = res.data || [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取体检预约记录列表
    getExamBookList() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning("无体检预约记录");
        return;
      }
      const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      const encodeEnDes = window.encodeURIComponent(enDes)
      let data = {
        hospitalCode: "H05",
        hisPatientId: encodeEnDes,
        pageNo: 1,
        pageSize: 100,
      };
      this.$API.getExamBookList(data).then((res) => {
        if (res.code == 0) {
          this.medicalData = res.data || [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取检验、检查报告查询列表
    getReportQueryOne() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning("无报告记录");
        return;
      }
      // hisPatientId
      const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      const encodeEnDes = window.encodeURIComponent(enDes)

      // cardNo
      const cardNos = this.consultantData.find((v)=>v.hisId==this.activeHisPatientId).cardNo;
      const cardNoEnDes = encryptByDES(cardNos, '6519625babf183f8')
      const cardNoEncodeEnDes = window.encodeURIComponent(cardNoEnDes)

      let data = {
        hospitalCode: "H05",
        hisPatientId: encodeEnDes,
        pageNo: 1,
        pageSize: 100,
        type: this.activeReportType,
        genre: '1',
        cardNo:cardNoEncodeEnDes
      };
      this.$API.getReportQueryOne(data).then((res) => {
        if (res.code == 0) {
          this.reportOneData = res.data || [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取体检报告查询列表
    getReportQueryTwo() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning("无报告记录");
        return;
      }
      const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      const encodeEnDes = window.encodeURIComponent(enDes)
      let data = {
        hospitalCode: "H05",
        hisPatientId: encodeEnDes,
        pageNo: 1,
        pageSize: 100,
      };
      this.$API.getReportQueryTwo(data).then((res) => {
        if (res.code == 0) {
          this.reportTwoData = res.data || [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取在院日清明细列表
    getNissinDetailList() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning("无在院日清明细记录");
        return;
      }
      const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      const encodeEnDes = window.encodeURIComponent(enDes)
      let data = {
        hospitalCode: "H05",
        hisPatientId: encodeEnDes,
        startDate: this.startDate,
        endDate: this.startDate,
      };
      this.$API.getNissinDetailList(data).then((res) => {
        if (res.code == 0) {
          this.statementDataOne = res.data || [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取已缴费记录列表
    getAlreadyPayCost() {
      if (this.activeHisPatientId == 0) {
        this.$message.warning("无已缴费记录");
        return;
      }
      const enDes = encryptByDES(this.activeHisPatientId, '6519625babf183f8')
      const encodeEnDes = window.encodeURIComponent(enDes)

      let data = {
        hospitalCode: "H05",
        hisPatientId:encodeEnDes,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      this.$API.getAlreadyPayCost(data).then((res) => {
        if (res.code == 0) {
          this.statementDataTwo = res.data.list || [];
          this.pagination.total = res.data.total || 0;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 取消门诊预约
    cancelSubscribe(orderCode) {
      this.cancelSubscribeOrderCode = orderCode;
      this.cancelSubscribeVisible = true;
    },
    // 确认取消门诊预约
    handleCancelSubscribeOk() {
      let data = {
        hospitalCode: "H05",
        orderCode: this.cancelSubscribeOrderCode,
      };
      this.$API.bookCancel(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("取消预约成功！");
          this.getOutpatientBookList();
          this.cancelSubscribeVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 门诊预约去支付
    goToPay(record) {
      if (!this.isShowMzFeeDialog) {
        return;
      }
      this.isShowMzFeeDialog = false;
      let orderCode = record.orderCode;
      let hisPatientId = record.hisPatientId;
      let fee = record.fee * 100; // 按分计算，返回值乘以100为元
      this.paymentRecord = record;
      this.paymentFee = record.fee;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 1000;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "relative";
      let data = {
        sys: "H05",
        source: "website",
        platform: "ZN",
        payType: "qrcode",
        businessId: "A1",
        businessType: "预约支付",
        productId: orderCode,
        productName: "门诊预约",
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      };
      this.$API.goPay(data).then((res) => {
        console.log("goPay res:", res);
        if (res && res.code == "0") {
          this.paymentQrCode = res.data;
          this.paymentVisible = true;
          this.getQrCode();
          this.isShowMzFeeDialog = true;
        }
      });
    },

    // 生成支付二维码
    getQrCode() {
      this.timer = setInterval(this.clock, 1000);
      let that = this;
      console.log("this inside qrcode:", that.paymentQrCode);
      let qrcode = require("qrcodejs2");
      document.getElementById("qrcode").innerHTML = "";
      new qrcode(document.getElementById("qrcode"), {
        text: that.paymentQrCode,
        width: 184,
        height: 184,
        correctLevel: qrcode.CorrectLevel.Q,
      });
    },
    // 计时器
    clock() {
      if (this.num > 0) {
        if (this.radioValue == 1) {
          this.checkPaymentStatus(); // 检查门诊预约支付状态
        }
        if (this.radioValue == 2) {
          this.checkExamPaymentStatus(); // 检查体检预约支付状态
        }
        this.num--;
      } else {
        clearInterval(this.timer);
        this.num = 60;
        if (this.radioValue == 1) {
          this.goToPay(this.paymentRecord); // 门诊预约重新支付
        }
        if (this.radioValue == 2) {
          this.immediatelyPay(this.paymentRecord); // 体检预约重新支付
        }
      }
    },
    // 查询门诊支付状态
    checkPaymentStatus() {
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: this.paymentRecord.hisPatientId,
        orderCode: this.paymentRecord.orderCode,
      };
      this.$API.checkPaymentStatus(data).then(
        (res) => {
          console.log("checkPaymentStatus res:", res);
          if (res && res.code == "0") {
            this.showHasPaySuccess = false;
            if (res.data == "P") {
              this.getOutpatientBookList();
              if (this.SCREEN.mobile) {
                this.closePayPhoneModal(); // 关闭手机端
              } else {
                this.closePaymentModal(); // 关闭PC端
              }
              this.openPaySuccessModal();
            }
          }
        },
        (error) => {
          console.log("checkPaymentStatus error:", error);
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal();
          } else {
            this.closePaymentModal();
          }
          this.showHasPaySuccess = false;
        }
      );
    },
    // 检查体检预约支付状态
    checkExamPaymentStatus() {
      // hisPatientId
      const enDes = encryptByDES(this.paymentRecord.hisPatientId, '6519625babf183f8');
      const encodeEnDes = window.encodeURIComponent(enDes)
      // idNo
      const idNoEnDes = encryptByDES(this.mineInfo.idNo, '6519625babf183f8')
      const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        idNo: idNoEncodeEnDes,
        idType: this.mineInfo.idType,
        reserveNetId: this.paymentRecord.reserveId,
      };
      this.$API.checkExamPaymentStatus(data).then(
        (res) => {
          console.log("checkExamPayStatus res:", res);
          if (res && res.code == "0") {
            this.showHasPaySuccess = false;
            if (res.data == "2") {
              this.getExamBookList();
              this.closePaymentModal();
              this.openPaySuccessModal();
            }
          }
        },
        (error) => {
          console.log("checkExamPaymentStatus error:", error);
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal();
          } else {
            this.closePaymentModal();
          }
          this.showHasPaySuccess = false;
        }
      );
    },
    // 关闭手机支付中弹框
    closePayPhoneModal() {
      this.payPhoneVisible = false;
      clearInterval(this.timer);
      this.num = 60;
    },
    // 门诊预约退号
    returnNum(orderCode, visitId) {
      this.returnNumOrderCode = orderCode;
      this.returnNumVisited = visitId;
      this.returnNumVisible = true;
    },
    // 确认退号
    handleReturnNumOk() {
      let data = {
        hospitalCode: "H05",
        orderCode: this.returnNumOrderCode,
        visitId: this.returnNumVisited,
      };
      this.$API.bookRefund(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("退号成功！");
          this.getOutpatientBookList();
          this.returnNumVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 预约记录
    makeAnAppointmentRocord(activeHisPatientId) {
      this.activeHisPatientId = activeHisPatientId;
      this.activeBox = 4;
      this.activeTab = 4;
      this.getOutpatientBookList();
    },
    // 门诊预约下拉人选择
    outpatientPeopleChange(value) {
      // this.activeHisPatientId =  value;
      this.getOutpatientBookList();
    },
    // 体检预约下拉人选择
    medicalAppointmentPeopleChange(value) {
      // this.activeHisPatientId =  value;
      this.getExamBookList();
    },
    // 打开pc新增就诊人弹窗
    addPcConsultantPeople() {
      this.visiblePc = true;
    },
    // 关闭pc新增就诊人弹窗
    closePcConsultantPeople() {
      console.log("closePcConsultantPeople:");
      this.visiblePc = false;
      this.consultantForm = {
        sys: "ohealth",
        hospitalCode: "H05",
        name: "",
        phone: "",
        idType: "01",
        idNo: "",
        birthday: "",
        gender: "1",
        relation: "0",
        verifyCode: "",
        source: "web",
        nation: "01",
        agreeCheck: false,
        agree360Check: false,
      };
    },
    // 清空就诊人表单
    resetConsultantForm() {
      this.consultantForm = {
        sys: "ohealth",
        hospitalCode: "H05",
        name: "",
        phone: "",
        idType: "01",
        idNo: "",
        birthday: "",
        gender: "1",
        relation: "0",
        verifyCode: "",
        source: "web",
        nation: "01",
        agreeCheck: false,
        agree360Check: false,
      };
    },
    // 打开手机端新增就诊人弹窗
    addMobileConsultantPeople() {
      this.visibleMobile = true;
    },
    // 打开手机端新增就诊人弹窗
    closeMobileConsultantPeople() {
      this.visibleMobile = false;
      this.consultantForm = {
        sys: "ohealth",
        hospitalCode: "H05",
        name: "",
        phone: "",
        idType: "01",
        idNo: "",
        birthday: "",
        gender: "1",
        relation: "0",
        verifyCode: "",
        source: "web",
        nation: "01",
        agreeCheck: false,
        agree360Check: false,
      };
    },
    // 查询省市县
    async getProvincesList() {
      const arrProvinces = [];
      const par = {};
      const res = await this.$API.getProvincesList(par);
      if (res.code === '0') {
        Object.keys(res.data).forEach((index) => {
          const itemLevel1 = {};
          itemLevel1.value = `${res.data[index].provinceName},${res.data[index].provinceCode}`;
          itemLevel1.label = res.data[index].provinceName;
          itemLevel1.children = [];
          const data = res.data[index].cities;
          let itemLevel2 = {};
          Object.keys(data).forEach((index1) => {
            const data2 = data[index1].counties;
            let itemLevel3 = {};
            itemLevel2.value = `${data[index1].cityName},${data[index1].cityCode}`;
            itemLevel2.label = data[index1].cityName;
            itemLevel2.children = [];
            Object.keys(data2).forEach((index2) => {
              itemLevel3.value = `${data2[index2].countyName},${data2[index2].countyCode}`;
              itemLevel3.label = data2[index2].countyName;
              itemLevel2.children.push(itemLevel3);
              itemLevel3 = {};
            });
            itemLevel1.children.push(itemLevel2);
            itemLevel2 = {};
          });
          arrProvinces.push(itemLevel1);
        });
        this.province = arrProvinces
      }
    },
    // 查询个人知情同意书在用信息
    getMicUsing() {
      const _this = this
      this.$API.getMicUsingSingle({
        hospitalCode: 'H05'
      }).then((res) => {
        if (res.code == 0 && res.data) {
          _this.mic = res.data;
        }
      });
    },
    // 新增就诊人确定
    async handleConsultantOk() {
      const _this = this
      if (!this.consultantForm.agreeCheck) {
        this.$message.warning('请先阅读并同意相关协议')
        return
      }
      console.log("新增就诊人表单", this.consultantForm);
      // 校验外国人永久居留证
      if (!this.consultantForm.name) {
        this.$message.error('请输入姓名');
        return false;
      }
      if (this.consultantForm.idType == "01") {
        if (!checkIdNo(this.consultantForm.idNo)) {
          this.$message.error('身份证号格式错误，请检查后输入');
          return false;
        }
      }else if (this.consultantForm.idType == "15") {
        const p = /(^[A-Za-z0-9]{15}|^[A-Za-z0-9]{18})$/;
        if (!p.test(this.consultantForm.idNo)) {
          this.$message.error("证件号格式错误，请输入15或18位证件号");
          return false;
        }
      } else {
        if (!checkIdTypes(this.consultantForm.idNo)) {
          this.$message.error('证件号格式错误，仅支持数字,字母');
          return false;
        }
      }
      if (!this.consultantForm.birthday) {
        this.$message.error('请选择出生日期');
        return false;
      }
      if (!checkPhoneNo(this.consultantForm.phone)) {
        this.$message.error('手机号码格式错误，请检查后重新输入');
        return false;
      }
      if (this.consultantForm.region.length < 1) {
        this.$message.error('请选择地址');
        return false;
      }
      if (!this.consultantForm.address) {
        this.$message.error('请输入详细地址');
        return false;
      }
      const Today = new Date(new Date().toLocaleString().split(" ")[0]).getTime();
      const getBirthday = new Date(this.consultantForm.birthday.replaceAll('-','/')).getTime();
      // 判断当前日期跟出生日期
      if (getBirthday > Today) {
        this.$message.error('出生日期不能晚于当前日期');
        return false;
      }
      this.confirmLoading = true;
      
      try {
        const provinceAddress = this.consultantForm.region
        const addressInfo = {
          provinceName: provinceAddress[0].split(',')[0] || '',
          provinceCode: provinceAddress[0].split(',')[1] || '',
          cityName: provinceAddress[1] ? (provinceAddress[1].split(',')[0] || '') : '',
          cityCode: provinceAddress[1] ? (provinceAddress[1].split(',')[1] || '' ): '',
          districtName: provinceAddress[2] ? (provinceAddress[2].split(',')[0] || '') : '',
          districtCode: provinceAddress[2] ? (provinceAddress[2].split(',')[1] || '') : '',
        };
        const addParams = JSON.parse(JSON.stringify({
          ...this.consultantForm,
          ...addressInfo
        }))
        delete addParams.region;
        let addRes = await this.$API.addPatient({
          ...addParams
        });
        if (addRes.code == 0) {
          this.$message.success("新增成功！");
          const signStatus = _this.consultantForm.agree360Check ? "1" : "0";
          this.visiblePc = false;
          this.visibleMobile = false;
          this.resetConsultantForm();
          this.getConsultantList();
          // TODO: 360视图 0---
          /* // 去签署
          const sendMsg = {
            hospitalCode: "H05",
            hisId: addRes.data,
            patientName: _this.consultantForm.name,
            micId: _this.mic.id,
            micVersion: _this.mic.micVersion,
            signStatus,
            secondSource: MIC_CONFIG.source, // 正式：boegw  测试：GW
          }
          console.log('360视图 0', sendMsg)
          const micSignRes = await this.$API.getMicSignSingle(sendMsg); */
          // TODO: 360视图 1---
        } else {
          this.$message.error(res.msg);
        }
        this.confirmLoading = false;
        console.log("执行this.confirmLoading", this.confirmLoading);
      } catch (error) {
        console.log(error);
        this.confirmLoading = false;
      }
    },
    // 解绑弹窗
    cancelBind(id, relationshipCode, relation) {
      this.cbVisible = true;
      this.activeCancelPeople.id = id;
      this.activeCancelPeople.relationshipCode = relationshipCode;
      this.activeCancelPeople.relation = relation;
    },
    // 确认解绑
    handleCbOk() {
      this.$API.patientDel(this.activeCancelPeople).then((res) => {
        if (res.code == 0) {
          this.$message.success("删除成功！");
          this.getConsultantList();
        } else {
          this.$message.error(res.msg);
        }
      });
      this.cbVisible = false;
    },
    // 取消解绑
    handleCbCancel() {
      this.cbVisible = false;
    },
    // 体检预约记录-取消预约
    cancelMakeAnAppointment(reserveId, hisPatientId) {
      this.cancelMakeAnAppointmentReserveId = reserveId;
      this.cancelMakeAnAppointmentHisPatientId = hisPatientId;
      this.cancelMakeAnAppointmentVisible = true;
    },
    // 体检预约记录-确认取消预约
    handleCancelMakeAnAppointmentOk() {
      let data = {
        hospitalCode: "H05",
        reserveId: this.cancelMakeAnAppointmentReserveId,
        hisPatientId: this.cancelMakeAnAppointmentHisPatientId,
      };
      this.$API.cancelExamBook(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("取消预约成功！");
          this.cancelMakeAnAppointmentVisible = false;
          this.getExamBookList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 体检预约记录-立即支付
    immediatelyPay(record) {
      if (!this.isShowTjFeeDialog) {
        return;
      }
      this.isShowTjFeeDialog = false;
      this.showPayModel = true;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 1000;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "relative";
      let orderCode =
        record.reserveId + "," + record.packageInfoList[0].packageCode;
      let hisPatientId = record.hisPatientId;
      let fee = record.packageInfoList[0].packagePrice * 100; // 按分计算，返回值乘以100为元
      this.paymentRecord = record;
      this.paymentRecord.fee = record.packageInfoList[0].packagePrice;
      this.paymentFee = record.packageInfoList[0].packagePrice;
      let data = {
        sys: "H05",
        source: "website",
        platform: "ZN",
        payType: "qrcode",
        businessId: "C1",
        businessType: "体检套餐支付",
        productId: orderCode,
        productName: "成都个人体检预约",
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      };
      this.$API.goPay(data).then((res) => {
        if (res && res.code == "0") {
          this.paymentQrCode = res.data;
          this.paymentVisible = true;
          this.getQrCode();
          this.isShowTjFeeDialog = true;
        }
      });
    },
    // 关闭支付弹窗
    closePayModel() {
      this.showPayModel = false;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 1;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "unset";
    },
    // 关闭支付成功弹窗
    closePaySuccessModel() {
      this.showPaySuccessModel = false;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 1;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "unset";
    },
    // 体检预约记录-重新预约
    refreshMakeAnAppointment() {
      // 跳转页面
       this.$router.push("/medicalCenter/medicalPlan");
    },
    // 门诊-重新预约
    appointmentAgain() {
      // 跳转页面
       this.$router.push("/medicalCenter/websiteBook");
    },
    // 报告查询下拉人选择
    reportConsultantPeopleChange(value) {
      this.activeHisPatientId = value;
    },
    // 报告类型选择下拉框
    // handleChangeReportType(value) {
    //   this.activeReportType = value;
    // },
    // 搜索报告按钮1
    searchReportOne() {
      this.showReport = 2;
      this.searchReportTwo();
    },
    // 搜索报告按钮2
    searchReportTwo() {
      if (this.activeReportType == "03") {
        this.getReportQueryTwo();
      } else {
        this.getReportQueryOne();
      }
    },
    // 报告预览
    reviewReport(path) {
      let data = {
        pdfUrl: path,
      };
      this.$message.warning("请耐心等待几秒钟");
      this.$API.getReportPdf(data).then((res) => {
        let binaryData = [];
        binaryData.push(res);
        let url = window.URL.createObjectURL(
          new Blob(binaryData, { type: "application/pdf;charset=UTF-8" })
        );
        this.iframeSrc =
          this.ROUTE_BASE +
          "/pdf/web/viewer.html?file=" +
          encodeURIComponent(url);
        this.showIframe = true;
        console.log("this.iframeSrc:", this.iframeSrc);
      });
    },
    // 将返回的流数据转换为url
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
        console.log("进入了1步骤window.createObjectURL");
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        console.log("进入了2步骤window.webkitURL.createObjectURL");
        try {
          url = window.webkitURL.createObjectURL(file);
        } catch (error) {}
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        console.log("进入了3步骤window.URL.createObjectURL");
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) {}
      }
      return url;
    },
    // 消费明细下拉选人
    statementConsultantPeopleChange(value) {
      this.activeHisPatientId = value;
    },
    // 获取消费明细
    getSevenChild(params) {
      if (params == 1) {
        this.showChildTab = 1;
        this.getNissinDetailList();
      } else {
        this.showChildTab = 2;
        this.getAlreadyPayCost();
      }
    },
    // 查询消费明细
    searchConsume() {
      if (this.showChildTab == 1) {
        this.getNissinDetailList();
      } else {
        this.getAlreadyPayCost();
      }
    },
    // 已缴费记录分页改变
    pageChange(page, pageSize) {
      console.log("page", page);
      this.pagination.current = page;
      this.getAlreadyPayCost();
    },
    // 切换tab
    changeTab(num) {
      this.activeTab = num;
      this.activeBox = num;
      if(num == 3){
        this.getConsultantList();
      }
      else if(num == 4){
        this.getOutpatientBookList();
        this.radioValue = 1;
      }
      else if(num == 5){
        this.getExamBookList();
        this.radioValue = 2;
      }else if(num == 6){
        this.showReport = 1;
      }else{
        this.showChildTab = 1;
        this.getNissinDetailList();
      }
    },
    // 支付弹窗返回
    handlePaymentCancel() {
      this.paymentVisible = false;
    },
    // 关闭支付弹窗
    closePaymentModal() {
      this.paymentVisible = false;
      clearInterval(this.timer);
      this.num = 60;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "unset";
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 5;
    },
    // 支付成功弹窗
    openPaySuccessModal() {
      this.paySuccessVisible = true;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "relative";
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 1000;
      // 支付成功计时器
      this.paySuccessTimer = setInterval(this.successClock, 1000);
    },
    // 支付成功计时器
    successClock() {
      if (this.paySuccessNum > 0) {
        this.paySuccessNum--;
      } else {
        this.closePaySuccessModal();
      }
    },
    // 关闭支付成功弹窗
    closePaySuccessModal() {
      this.paySuccessVisible = false;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "unset";
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 5;
      clearInterval(this.paySuccessTimer);
      this.paySuccessNum = 5;
    },
    // 门诊去付款手机端
    goPaymentPhone(record) {
      let orderCode = record.orderCode;
      let hisPatientId = record.hisPatientId;
      let fee = record.fee * 100; // 按分计算，返回值乘以100为元
      this.paymentRecord = record;
      this.paymentFee = record.fee;
      let data = {
        sys: "H05",
        source: "website",
        platform: "ZN",
        payType: "h5",
        businessId: "A1",
        businessType: "预约支付",
        productId: orderCode,
        productName: "门诊预约",
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      };
      this.$API.goPayPhone(data).then((res) => {
        if (res && res.code == "0") {
          this.paymentQrCode = res.data;
          let u = navigator.userAgent;
          let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isAndroid) {
            //android终端
            window.open(this.paymentQrCode, "_blank");
          } else if (isiOS) {
            //ios终端
            window.location.href = this.paymentQrCode;
          }
          this.openPayPhoneModal();
        }
      });
    },
    // 打开手机支付中弹框
    // openPayPhoneModal(){
    // this.payPhoneVisible = true;
    // this.timer = setInterval(this.phoneClock, 1000);
    // },
    // 打开手机支付待确认弹框
    openPayPhoneModal() {
      let timer = setTimeout(() => {
        this.showHasPaySuccess = true;
        clearTimeout(timer);
      }, 3000);
    },
    // 已完成支付
    hasPaySuccess() {
      if (this.radioValue == 1) {
        this.checkPaymentStatus(); // 检查门诊预约支付状态
      }
      if (this.radioValue == 2) {
        this.checkExamPaymentStatus(); // 检查体检预约支付状态
      }
    },
    // 重新支付
    refreshPay() {
      if (this.radioValue == 1) {
        this.goPaymentPhone(this.paymentRecord); // 调用门诊支付接口
      }
      if (this.radioValue == 2) {
        this.goExamPaymentPhone(this.paymentRecord); // 调用体检支付接口
      }
    },
    // 手机计时器
    phoneClock() {
      if (this.num > 0) {
        if (this.radioValue == 1) {
          this.checkPaymentStatus(); // 检查门诊预约支付状态
        }
        if (this.radioValue == 2) {
          this.checkExamPaymentStatus(); // 检查体检预约支付状态
        }
        this.num--;
      } else {
        this.closePayPhoneModal();
      }
    },
    // 关闭手机支付中弹框
    closePayPhoneModal() {
      this.payPhoneVisible = false;
      clearInterval(this.timer);
      this.num = 60;
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.position = "unset";
      document.getElementsByClassName(
        "person-center-tab-wrap"
      )[0].style.zIndex = 5;
    },

    // 体检手机端去付款
    goExamPaymentPhone(record) {
      let orderCode =
        record.reserveId + "," + record.packageInfoList[0].packageCode;
      let hisPatientId = record.hisPatientId;
      let fee = record.packageInfoList[0].packagePrice * 100; // 按分计算，返回值乘以100为元
      this.paymentRecord = record;
      this.paymentRecord.fee = record.packageInfoList[0].packagePrice;
      this.paymentFee = record.packageInfoList[0].packagePrice;
      this.examBooKMail = record.packageInfoList[0].packageName;
      this.examBookTime = record.reserveDate;
      let data = {
        sys: "H05",
        source: "website",
        platform: "ZN",
        payType: "h5",
        businessId: "C1",
        businessType: "体检套餐支付",
        productId: orderCode,
        productName: "成都个人体检预约",
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      };
      this.$API.goPayPhone(data).then((res) => {
        console.log("goPayPhone res:", res);
        if (res && res.code == "0") {
          this.paymentQrCode = res.data;
          let u = navigator.userAgent;
          let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isAndroid) {
            //android终端
            window.open(this.paymentQrCode, "_blank");
          } else if (isiOS) {
            //ios终端
            window.location.href = this.paymentQrCode;
          }
          this.openPayPhoneModal();
        }
      });
    },
    // 体检取消预约退款
    goExamRefund(value) {
      let that = this;
      this.$confirm({
        title: "提示",
        content: "确认取消预约退款？",
        onOk() {
          that.$API
            .examRefund({
              hospitalCode: that.hospitalCode,
              reserveNetId: value.reserveId,
              packageCode: value.packageInfoList[0].packageCode,
            })
            .then((res) => {
              if (res && res.code == 0) {
                that.getExamBookList();
              }
            });
        },
        onCancel() {},
      });
    },
    // 输入身份证号自动带出出生日期
    enterIdNo() {
      console.log("enterIdNo:", this.consultantForm.idNo);
      if (
        this.consultantForm.idType == "01" &&
        this.consultantForm.idNo.length == 18
      ) {
        let str1 = this.consultantForm.idNo.substring(6, 10);
        let str2 = this.consultantForm.idNo.substring(10, 12);
        let str3 = this.consultantForm.idNo.substring(12, 14);
        let gender = this.consultantForm.idNo.substring(16, 17);
        this.consultantForm.birthday = str1 + "-" + str2 + "-" + str3;
        if (gender % 2 == 1) {
          this.consultantForm.gender = "1";
        } else {
          this.consultantForm.gender = "2";
        }
      }
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (process.client) {
          let pathList = to.fullPath.split("#");
          let params = pathList[1];
          switch (params) {
            case "overview1":
              this.activeBox = 1;
              this.activeTab = 1;
              this.getConsultantList();
              break;
            case "overview2":
              this.activeBox = 2;
              this.activeTab = 2;
              this.getConsultantList();
              break;
            case "overview3":
              this.activeBox = 3;
              this.activeTab = 3;
              console.log("执行了 3");
              this.getConsultantList();
              break;
            case "overview4":
              this.activeBox = 4;
              this.activeTab = 4;
              let time4 = setTimeout(() => {
                console.log("执行了 4");
                this.getOutpatientBookList();
                clearTimeout(time4);
              }, 2000);
              break;
            case "overview5":
              this.activeBox = 5;
              this.activeTab = 5;
              let time5 = setTimeout(() => {
                console.log("执行了 5");
                this.getExamBookList();
                clearTimeout(time5);
              }, 2000);
              break;
            case "overview6":
              this.activeBox = 6;
              this.activeTab = 6;
              this.showReport = 1;
              console.log("执行了 6");
              break;
            case "overview7":
              this.activeBox = 7;
              this.activeTab = 7;
              let time7 = setTimeout(() => {
                console.log("执行了 7");
                this.searchConsume();
                clearTimeout(time7);
              }, 2000);
              break;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.person-center-tab-wrap {
  position: relative;
  z-index: 1;
  padding-top: 50px;
  padding-bottom: 50px;
  &::after {
    clear: both;
    content: "";
    display: block;
    overflow: hidden;
    visibility: hidden;
  }
  /deep/ .ant-table-thead > tr > th {
    background: #0079d4;
    color: #fff;
  }
  img {
    display: inline-block;
  }
  .btn {
    display: inline-block;
    padding: 2px 5px;
    background-color: #0079d4;
    color: #fff;
    border-radius: 4px;
    &:not(:first-child){
      margin-left:5px
    }
  }
  .btn-default {
    background-color: #dbdada;
    color: #333;
  }
  .btn-blue {
    background-color: #65b3ec;
  }
  .left-box {
    .top-box {
      background-color: #0079d4;
      color: #fff;
      height: 120px;
      line-height: 120px;
      font-size: 30px;
      img {
        position: relative;
        left: 40px;
      }
      span {
        position: relative;
        left: 40px;
      }
    }
    li {
      background-color: #0065b5;
      color: #fff;
      padding-left: 30px;
      padding-right: 20px;
      height: 60px;
      line-height: 60px;
      border-top: 1px solid #005aa2;
      &:hover {
        cursor: pointer;
      }
      &.active {
        background-color: #0079d4;
      }
      img {
        position: relative;
        top: -5px;
      }
      span {
        font-size: 18px;
      }
      .one-span {
        position: relative;
        left: 10px;
      }
      .two-span {
        float: right;
        font-size: 20px;
      }
    }
  }
  .admb-5-px {
    margin-bottom: 5px;
  }
}
.m-screen-pc {
  .left-box {
    float: left;
    width: 280px;
  }
  .right-box {
    width: 900px;
    float: right;
  }
  .consultant-management {
    h2 {
      margin-bottom: 20px;
      font-size: 24px;
    }
    .add-consultant-people {
      margin-bottom: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .one-span {
        display: inline-block;
        width: 200px;
        height: 60px;
        line-height: 60px;
        background-color: #60aae0;
        font-size: 16px;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }
      .two-span {
        font-size: 16px;
      }
    }
    .eCardArea {
      // width: 100%;
      // margin: 10px auto;
      font-family: PingFangSC-Medium;
      .eCardBox {
        padding: 15px 10px 9px 21px;
        width: 380px;
        height: 208px;
        background: url(../images/eCard-back.png) no-repeat left center;
        background-size: cover;
        .eCardFirstRow {
          display: flex;
          margin-bottom: 9px;
          .eCardLeft {
            width: 200px;
            .siChuan {
              font-size: 12px;
              padding-top: 2px;
              padding-bottom: 73px;
            }
            .name {
              font-size: 24px;
            }
            .relation {
              font-size: 16px;
              color: #666666;
            }
            .idNo {
              font-size: 20px;
            }
          }
          .eCardRight {
            width: 145px;
            .rightFristRow {
              display: flex;
              margin-bottom: 20px;
              margin-left: 5px;
              align-items: center;
              .redCrossImg {
                width: 32px;
              }
              .content {
                font-size: 20px;
                margin-left: 5px;
              }
            }
            .qrCodeBox {
              background: white;
              padding: 2px;
              margin-left: 42px;
              position: relative;
              .logoImg {
                width: 26px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -13px;
                margin-left: -13px;
              }
              .qrCode {
                width: 98px;
                height: 98px;
              }
            }
          }
        }
        .eCardSecondRow {
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
  .outpatient-appointment,
  .medical-appointment {
    .outpatient-people {
      margin-bottom: 16px;
      &::after {
        clear: both;
        content: "";
        display: block;
        visibility: hidden;
        overflow: hidden;
      }
    }
    h2,
    .select {
      float: left;
    }
    h2 {
      margin-right: 20px;
      font-size: 24px;
    }
    .select {
      width: 300px;
      position: relative;
      top: 4px;
    }
    .two-span {
      float: right;
      position: relative;
      top: 5px;
      font-size: 16px;
    }
  }
  .report-query {
    .report-title-box {
      .report-title {
        margin-right: 20px;
        font-size: 24px;
      }
      .select {
        width: 300px;
      }
    }
    .report-main-box {
      margin-top: 20px;
      padding: 80px;
      box-shadow: 0 4px 16px #ddd, 0 0 4px #ddd, 0 0 4px #ddd;
      .type-box {
        margin-bottom: 10px;
        .type-span {
          font-size: 16px;
        }
        .select {
          width: 614px;
        }
      }
      .time-box {
        margin-bottom: 30px;
        .time-span {
          font-size: 16px;
        }
        .time-picker {
          width: 280px;
        }
        .to {
          margin: 0 17px;
        }
      }
      .search-box {
        margin-bottom: 60px;
        text-align: center;
        .btn-box {
          display: inline-block;
          text-align: center;
          width: 300px;
          height: 55px;
          line-height: 55px;
          background-color: #0079d4;
          color: #fff;
          border-radius: 40px;
          img {
            margin-right: 10px;
          }
          .search-span {
            font-size: 16px;
          }
        }
      }
      .report-tab {
        .report-tab-head {
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          p {
            position: relative;
            width: 193px;
            height: 55px;
            line-height: 55px;
            background-color: #65b3ec;
            text-align: center;
            border-radius: 4px;
            .text {
              color: #fff;
              font-size: 16px;
            }
            img {
              margin-right: 10px;
            }
            .triangle {
              position: absolute;
              bottom: -10px;
              left: 90px;
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 10px solid #0078d4;
            }
            &.active {
              background-color: #0079d4;
            }
          }
        }
      }
    }
    .search-two-box {
      margin: 10px 0 20px 0;
      .type-span,
      .time-span,
      .to {
        font-size: 16px;
      }
      .time-span {
        margin-left: 10px;
      }
      .to {
        margin: 0 10px;
      }
      .select {
        width: 200px;
      }
      .time-picker {
        width: 150px;
      }
      .search-btn {
        margin-left: 10px;
        display: inline-block;
        width: 97px;
        height: 32px;
        background: #0079d4;
        color: #fff;
        text-align: center;
        line-height: 32px;
        border-radius: 22px;
        font-size: 16px;
      }
    }
  }
  .statement {
    .title-box {
      .consumption-span {
        margin-right: 20px;
        font-size: 24px;
      }
      .select {
        width: 300px;
      }
    }
    .search-box {
      margin-top: 20px;
      margin-bottom: 1px;
      .one-span,
      .two-span {
        display: inline-block;
        width: 112px;
        height: 54px;
        line-height: 54px;
        border: 1px solid #bebebe;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        &.active {
          background: #0079d4;
          border-color: #0079d4;
          color: #fff;
        }
      }
      .three-span {
        margin-left: 20px;
      }
      .to {
        margin: 0 6px;
      }
      .five-span {
        margin-left: 10px;
        display: inline-block;
        width: 97px;
        height: 44px;
        background: #0079d4;
        color: #fff;
        text-align: center;
        line-height: 44px;
        border-radius: 22px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
  .iframe-box {
    position: fixed;
    top: 2%;
    left: 10%;
    width: 80%;
    height: 90%;
    z-index: 10000;
    .close-span {
      position: absolute;
      right: -37px;
      top: -10px;
      background: #aaa;
      padding: 10px 15px;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
    }
  }
}

.m-screen-mobile {
  .left-box {
    margin: 0 auto;
    float: none;
    width: 96%;
    .top-box {
      height: 1.5rem;
      line-height: 1.5rem;
      img {
        height: 1rem;
      }
      span {
        font-size: 24px;
      }
    }
    li {
      height: 1rem;
      line-height: 1rem;
    }
  }
  .right-box {
    margin: 0 auto;
    float: none;
    width: 96%;
  }
  .consultant-management {
    h2 {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 24px;
      text-align: center;
    }
    .add-consultant-people {
      margin-bottom: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .one-span {
        display: inline-block;
        width: 3rem;
        height: 1rem;
        line-height: 1rem;
        background-color: #60aae0;
        font-size: 14px;
        text-align: center;
        color: #fff;
      }
      .two-span {
        font-size: 14px;
      }
    }
    .eCardArea {
      // width: 100%;
      margin: 10px 20px;
      font-family: PingFangSC-Medium;
      .eCardBox {
        padding: 0.23rem 0.15rem 0.16rem 0.35rem;
        width: 6.2rem;
        height: 3.5rem;
        background: url(../images/eCard-back.png) no-repeat left center;
        background-size: cover;
        .eCardFirstRow {
          display: flex;
          margin-bottom: 0.03rem;
          .eCardLeft {
            width: 3.5rem;
            .siChuan {
              font-size: 0.18rem;
              padding-top: 0.02rem;
              padding-bottom: 1.33rem;
            }
            .name {
              font-size: 0.36rem;
            }
            .relation {
              font-size: 0.16rem;
              color: #666666;
            }
            .idNo {
              font-size: 0.3rem;
            }
          }
          .eCardRight {
            width: 2.3rem;
            .rightFristRow {
              display: flex;
              margin-bottom: 0.4rem;
              margin-left: 0.05rem;
              align-items: center;
              .redCrossImg {
                width: 0.55rem;
              }
              .content {
                font-size: 0.3rem;
                margin-left: 0.08rem;
              }
            }
            .qrCodeBox {
              background: white;
              padding: 0.02rem;
              margin-left: 0.52rem;
              position: relative;
              .logoImg {
                width: 0.36rem;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -0.15rem;
                margin-left: -0.15rem;
              }
              .qrCode {
                width: 1.54rem;
                height: 1.54rem;
              }
            }
          }
        }
        .eCardSecondRow {
          font-size: 0.18rem;
          text-align: center;
        }
      }
    }
    .line {
      margin: 10px 0;
      width: 100%;
      height: 0;
      border-bottom: 1px solid #ddd;
    }
  }
  .mobile-table {
    ul {
      margin-bottom: 10px;
    }
    li {
      height: 1rem;
      line-height: 1rem;
      background-color: #f5f5f5;
      border-bottom: 1px solid #e8e8e8;
      &:first-child {
        border-top: 1px solid #e8e8e8;
      }
      &::after {
        clear: both;
        content: "";
        display: block;
        overflow: hidden;
        visibility: hidden;
      }
      .one-span {
        text-align: right;
        float: left;
        width: 30%;
        font-size: 14px;
      }
      .two-span {
        box-sizing: border-box;
        float: left;
        font-size: 14px;
        width: 69%;
        padding-left: 8px;
        height: 1rem;
        overflow: hidden;
      }
    }
  }
  .btn {
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 5px;
  }
  .outpatient-mobile-people {
    h2 {
      margin: 20px 0;
      text-align: center;
    }
    .select {
      width: 100%;
      /deep/ .ant-select-selection-selected-value {
        width: 100%;
        text-align: center;
      }
    }
    .two-span {
      margin: 20px 0;
      display: block;
      text-align: center;
    }
  }
  .report-query {
    .report-title-box {
      text-align: center;
      .report-title {
        margin: 0.5rem 0;
        text-align: center;
        font-size: 0.5rem;
        width: 100%;
        display: block;
      }
      .select {
        width: 100%;
        /deep/ .ant-select-selection-selected-value {
          width: 100%;
          text-align: center;
        }
      }
    }
    .report-main-box {
      margin-top: 20px;
      padding: 0.25rem;
      box-shadow: 0 4px 16px #ddd, 0 0 4px #ddd, 0 0 4px #ddd;
      .type-box {
        margin-bottom: 10px;
        .type-span {
          font-size: 0.4rem;
        }
        .select {
          width: 5.3rem;
        }
      }
      .time-box {
        margin-bottom: 30px;
        .time-span {
          font-size: 0.4rem;
        }
        .time-picker {
          width: 2.4rem;
        }
      }
      .search-box {
        margin-bottom: 0.5rem;
        text-align: center;
        .btn-box {
          display: inline-block;
          text-align: center;
          width: 100%;
          height: 0.8rem;
          line-height: 0.8rem;
          background-color: #0079d4;
          color: #fff;
          border-radius: 0.6rem;
          img {
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 0.15rem;
          }
          .search-span {
            font-size: 0.4rem;
          }
        }
      }
      .report-tab {
        .report-tab-head {
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          p {
            position: relative;
            width: 2.4rem;
            height: 1rem;
            line-height: 1rem;
            background-color: #65b3ec;
            text-align: center;
            border-radius: 4px;
            .text {
              color: #fff;
              font-size: 0.3rem;
            }
            img {
              position: relative;
              top: -0.1rem;
              width: 0.4rem;
              height: 0.4rem;
              margin-right: 0.1rem;
            }
            .triangle {
              position: absolute;
              bottom: -0.25rem;
              left: 1rem;
              width: 0;
              height: 0;
              border-left: 0.25rem solid transparent;
              border-right: 0.25rem solid transparent;
              border-top: 0.25rem solid #0078d4;
            }
            &.active {
              background-color: #0079d4;
            }
          }
        }
      }
    }
    .report-two-title-box {
      margin-bottom: 0.5rem;
      .report-title {
        margin: 0.25rem 0;
        text-align: center;
        font-size: 0.4rem;
      }
      .select {
        width: 100%;
        /deep/ .ant-select-selection-selected-value {
          width: 100%;
          text-align: center;
        }
      }
    }
    .search-three-box {
      margin-bottom: 0.25rem;
      .select {
        width: 6.1rem;
      }
    }
    .search-four-box {
      margin-bottom: 0.5rem;
      .time-picker {
        width: 2.8rem;
      }
    }
    .search-btn-box {
      margin-bottom: 0.8rem;
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      background: #0079d4;
      color: #fff;
      border-radius: 1rem;
    }
    .line {
      margin-bottom: 0.25rem;
      width: 100%;
      height: 0;
      border-bottom: 2px solid #ddd;
    }
  }
  .statement {
    .title-box {
      margin-bottom: 0.4rem;
      .consumption-h2 {
        margin: 0.5rem 0;
        text-align: center;
      }
      .select {
        width: 100%;
        /deep/ .ant-select-selection-selected-value {
          width: 100%;
          text-align: center;
        }
      }
    }
    .search-box-one {
      margin-bottom: 0.25rem;
      display: flex;
      justify-content: space-between;
      span {
        display: inline-block;
        height: 1rem;
        line-height: 1rem;
        width: 49%;
        font-size: 0.3rem;
        border: 1px solid #bebebe;
        border-radius: 4px;
        text-align: center;
        &.active {
          background: #0079d4;
          border-color: #0079d4;
          color: #fff;
        }
      }
    }
    .search-box-two {
      margin-bottom: 0.25rem;
      .time-picker {
        width: 2.8rem;
      }
      .search-div {
        margin-top: 0.25rem;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: #0079d4;
        color: #fff;
        border-radius: 0.5rem;
      }
    }
  }
  .iframe-box {
    position: fixed;
    top: 2%;
    left: 10%;
    width: 80%;
    height: 90%;
    z-index: 10000;
    .close-span {
      position: absolute;
      right: -37px;
      top: -10px;
      background: #aaa;
      padding: 10px 15px;
      border-radius: 50%;
      color: #fff;
      cursor: pointer;
    }
  }
}

.add-consultant-people-dialog {
  padding: 20px;
  .width-220-px {
    width: 220px;
  }
  ul {
    &::after {
      clear: both;
      content: "";
      display: block;
      overflow: hidden;
      visibility: hidden;
    }
  }
  li {
    float: left;
    margin-bottom: 10px;
    width: 50%;
    .one-span {
      float: left;
      width: 30%;
      height: 32px;
      line-height: 32px;
    }
    .two-span {
      float: left;
      width: 70%;
      position: relative;
    }
    .send-yzm {
      position: absolute;
      top: 0;
      right: 36px;
      width: 80px;
      height: 32px;
      line-height: 32px;
      background-color: #0078d4;
      color: #fff;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
.add-consultant-people-mobile-dialog {
  li {
    .one-span,
    .two-span {
      display: block;
      width: 100%;
      margin-bottom: 0.25rem;
    }
    .select {
      width: 100%;
    }
    .two-span {
      position: relative;
      .send-yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 2rem;
        height: 32px;
        line-height: 32px;
        background-color: #0078d4;
        color: #fff;
        text-align: center;
        border-radius: 4px;
      }
    }
  }
}

.paymentModal {
  /deep/ .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .qrcodeBox {
            width: 145px;
            height: 145px;
            margin: 0 auto;
            margin-top: 15px;
          }
        }
        .ant-modal-footer {
          text-align: right;
        }
      }
    }
  }
}

.qrcodeBox1 {
  width: 145px;
  height: 145px;
  margin: 0 auto;
  margin-top: 15px;
}

.wemsk {
  background: url(../images/mask50.png);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9998;
  left: 0;
  top: 0;
  display: block;
}
.ewmboxfix {
  // -webkit-box-shadow: 0px 1px 20px 0px #f5f5f5;
  // box-shadow: 0px 1px 20px 0px #f5f5f5;
  width: 50%;
  // height: 50%;
  overflow: hidden;
  border-radius: 5px;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 30%;
  margin-left: -25%;
  // margin-top: -25%;
  background: #fff;
  border: 5px solid #fff;
  display: block;
  padding: 20px;
  .closeBtn {
    text-align: right;
    margin-bottom: 20px;
  }
  .payInfo {
    margin-bottom: 20px;
    .left {
      .main {
        font-size: 0.18rem;
        color: #222222;
        font-weight: 400;
      }
      .txt {
        margin-top: 0.18rem;
        font-size: 0.16rem;
        color: #999999;
        font-weight: 400;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .payable {
        font-size: 0.2rem;
        color: #333333;
        font-weight: 400;
      }
      .money {
        font-size: 0.26rem;
        color: #f29e0c;
        font-weight: 400;
      }
    }
  }
  .qrcodeBox {
    width: 145px;
    margin: 0 auto 20px;
  }
  .tipInfo {
    font-size: 0.18rem;
  }
}
.pay-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -288px;
  margin-left: -331px;
  width: 662px;
  height: 576px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .pay-main-box {
    .title {
      width: 100%;
      height: 120px;
      background-color: #f8f9ff;
      .top-title {
        padding-top: 20px;
        text-align: center;
        font-size: 18px;
        position: relative;
        font-weight: bold;
        .close-span {
          position: absolute;
          right: 20px;
          top: 0px;
          color: #999;
          font-size: 30px;
          font-weight: normal;
          cursor: pointer;
        }
      }
      .two-box {
        margin: 10px 0;
        text-align: center;
        font-size: 12px;
        span {
          font-weight: bold;
        }
      }
      .three-box {
        text-align: center;
        span {
          font-weight: bold;
        }
      }
    }
    .pay-money {
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      span {
        color: #ff4d4f;
        font-size: 24px;
      }
    }
    .img-box {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 0 80px;
      display: flex;
      justify-content: space-between;
      .left-img-box {
        border: 1px solid #ddd;
        .qrcode-box {
          width: 224px;
          height: 224px;
          padding: 20px;
          #qrcode {
            width: 100%;
            height: 100%;
          }
        }
        .bottom-remind-box {
          box-sizing: border-box;
          margin-top: 12px;
          padding-top: 8px;
          padding-left: 20px;
          border-top: 1px solid #ddd;
          &::after {
            clear: both;
            display: block;
            content: "";
            overflow: hidden;
          }
          .img {
            float: left;
          }
          .txt {
            margin-left: 20px;
            float: left;
            font-size: 12px;
          }
        }
      }
      .right-img-box {
        img {
          width: 210px;
          height: 288px;
        }
      }
    }
    .red-txt-box {
      margin-top: 20px;
      padding: 0 80px;
      .content-red-box {
        background-color: #fff1f0;
        border: 1px solid #ffa39e;
        padding-left: 24px;
        height: 40px;
        line-height: 40px;
        img {
          margin-right: 8px;
        }
      }
    }
  }
}
.pay-success-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -130px;
  margin-left: -331px;
  width: 662px;
  height: 260px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .top-title {
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    position: relative;
    font-weight: bold;
    .close-span {
      position: absolute;
      right: 20px;
      top: -16px;
      color: #999;
      font-size: 30px;
      font-weight: normal;
      cursor: pointer;
    }
  }
  .middle-box {
    margin: 60px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    img {
      margin-right: 10px;
      width: 50px;
      height: 50px;
    }
    span {
      color: #ff7f81;
    }
  }
  .bottom-box {
    text-align: center;
    font-size: 12px;
    color: #404555;
  }
}
.has-pay-success {
  position: fixed;
  width: 4rem;
  height: 2.5rem;
  z-index: 9999;
  top: 30%;
  left: 20%;
  background-color: #fff;
  border-radius: 6px;
  .gth-box {
    margin-top: 0.2rem;
    text-align: center;
    .gth {
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      border: 1px solid red;
      color: red;
    }
  }
  .txt {
    margin: 10px 0;
    text-align: center;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    padding: 0 0.2rem;
    p {
      border: 1px solid #ddd;
      padding: 0.1rem 0.2rem;
      border-radius: 0.5rem;
    }
    .red-btn {
      background-color: red;
      border-color: red;
      color: #fff;
    }
  }
}
</style>
